const translations = {
  fr: {
    // Navigation
    home: "Accueil",
    audiometricTest: "Explorer mon écoute",
    tinnitusTest: "Explorer mes acouphènes",
    therapy: "Paysages sonores",
    playlists: "Playlists",
    playlistsDesc: "Créez et écoutez vos sessions d'écoute personnalisées",
    playlistsHomeDesc: "Vos sons personnalisés",
    myPlaylists: "Mes Playlists",
    playlistsSubtitle: "Vos sons personnalisés",
    history: "Historique",
    progress: "Suivi des Progrès",
    profile: "Profil",
    guide: "Guide",
    
    // Home tiles
    soundscapes: "Paysages sonores",
    yourSpace: "Ton espace",
    soundscapesHomeDesc: "Son immersif. Sans voix.",
    presence: "Présence",
    presenceHomeDesc: "La voix d'Hera.",
    nightMode: "Cocoon",
    nightModeHomeDesc: "Un espace doux quand le silence devient trop présent",
    nightModeSubtitle: "Un espace doux quand le silence devient trop présent",
    nightModeEnter: "Entrer dans Cocoon",
    nightModePlaying: "En lecture",
    nightModePaused: "En pause",
    nightModeTransition: "Transition...",
    nightModeNext: "Suivant",
    sosCalm: "SOS Calm",
    sosCalmHomeDesc: "Calme instantané, en un tap",
    
    // Home Hero - V1.1.1
    homeHeroTitle: "Entrez dans le calme",
    homeHeroSubtitle: "Un geste. Un espace infini.",
    
    // V1.1: Home redesign
    homeV11Title: "Your Space",
    homeV11Subtitle: "Choisis ton ambiance.",
    comingSoon: "Bientôt",
    tabHome: "Accueil",
    tabFavorites: "Favoris",
    tabProfile: "Profil",
    favoritesTitle: "Favoris",
    favoritesLabel: "Favoris",
    playlistsLabel: "Playlists",
    noFavorites: "Aucun favori pour le moment",
    noPlaylists: "Aucune playlist",
    tracks: "pistes",
    addToPlaylist: "Ajouter a une playlist",
    soundAddedToPlaylist: "Son ajoute a la playlist",
    playlistCreatedSuccess: "Playlist creee",
    enterPlaylistName: "Nom de la playlist",
    createNewPlaylist: "Nouvelle playlist",
    deletePlaylistTitle: "Supprimer la playlist ?",
    playlistDeleted: "Playlist supprimee",
    trackRemoved: "Piste retiree",
    session: "Session",
    voiceGuidance: "Voix guidee",
    voiceOnDesc: "Hera vous accompagne",
    voiceOffDesc: "Son immersif uniquement",
    startSession: "Demarrer la session",
    themes: {
      nature: "Nature",
      relaxation: "Relaxation",
      sleep: "Sommeil",
      meditation: "Méditation",
      pulseFlow: "Pulse Flow",
      instrumental: "Instrumental",
      lofi: "Lofi",
      deepCalm: "Deep Calm",
    },

  player: {
      audio_profile_active:
        'Profil d’écoute actif',

      presence_audio_profile_active:
        'Présence Hera · Profil d’écoute actif',
  },
   
    matrix: {
    profile_ready:
      "Votre écoute est prête.",

    hera_profile_ready:
      "Votre écoute est déjà personnalisée. Laissez Hearen faire le reste.",

    adjust_listening:
    "Ajuster mon écoute →",


     discovery: "Vous pouvez commencer doucement.",
     evening_return: "Retrouver doucement votre ambiance du soir.",
     fatigue_softening: "Un moment calme pourrait vous faire du bien.",
     ready_for_deeper:
       "Quelques minutes peuvent doucement enrichir votre écoute.",

     hera_breathe_and_listen:
       "Prenez simplement quelques instants pour écouter.",

     hera_evening_soft_listening:
       "Ce soir, une écoute douce pourrait suffire.",

     hera_no_need_to_force:
       "Vous n’avez rien à réussir maintenant. Juste écouter.",

     hera_familiar_sound:
       "Un paysage sonore familier peut parfois aider davantage qu’un nouveau.",

     hera_personalization_can_wait:
       "Vous pouvez personnaliser plus tard. Pour l’instant, quelques minutes d’écoute peuvent suffire.",
   },
    
    // Progress page
    locale: "fr-FR",
    progressScore: "Score de progrès",
    exportPDF: "Exporter PDF",
    exportPDFSoon: "Export PDF sera disponible prochainement",
    days: "jours",
    trendImproving: "Excellente progression !",
    trendAttention: "En progression - Continuez !",
    trendStable: "Évolution positive",
    kpiDays: "Jours",
    kpiMin: "Min",
    kpiVAS: "VAS",
    kpiTinnitus: "Acouphènes",
    kpiHz: "Hz",
    kpiDaysTooltip: "Nombre de jours où vous avez effectué au moins une session d'écoute",
    kpiMinTooltip: "Durée moyenne de vos sessions d'écoute par jour",
    kpiVASTooltip: "Votre dernière évaluation de l'intensité de vos acouphènes (échelle 1-10)",
    kpiVASTooltipTitle: "📊 VAS - Échelle Visuelle Analogique",
    kpiVASTooltipDesc: "Mesure l'intensité ressentie de vos acouphènes de 1 (très faible) à 10 (insupportable).",
    kpiVASTooltipCurrent: "Score actuel:",
    kpiVASTooltipBaseline: "Score initial:",
    kpiVASTooltipNote: "💡 Un score plus bas indique une amélioration",
    kpiVASFrom: "depuis",
    kpiTinnitusTooltip: "Fréquence dominante de vos acouphènes détectée lors de votre dernier test",
    labDescription: "Accédez aux programmes expérimentaux Notch et Inverse Notch",
    
    dailyScoreTooltipTitle: "🧮 Comment est calculé le Score Quotidien ?",
    dailyScoreCase1: "Cas 1: VAS + Écoute",
    dailyScoreCase1Desc: "Score = (Score VAS × 50%) + (Score Adhérence × 50%)",
    dailyScoreCase1Example: "• Score VAS: (10 - votre_VAS) × 10 (VAS bas = meilleur)",
    dailyScoreCase1Example2: "• Score Adhérence: (minutes / 15) × 100 (15min = 100%)",
    dailyScoreCase2: "Cas 2: Écoute uniquement",
    dailyScoreCase2Desc: "Score = (minutes / 15) × 100",
    dailyScoreCase2Example: "• 15 minutes = 100 points • 30 minutes = 100 points (max)",
    dailyScoreCase3: "Cas 3: VAS uniquement",
    dailyScoreCase3Desc: "Score = (10 - votre_VAS) × 10",
    dailyScoreNote: "💡 Note: Un score élevé = bonne journée (VAS bas + écoute régulière)",
    
    // Progress Page Update - Spec Nov 2025
    progressBannerTitle: "Aperçu de Vos Progrès",
    progressBannerDesc: "Suivez votre temps d'écoute, votre perception des acouphènes et l'évolution de votre bien-être quotidien.",
    
    // KPI Cards - New Wording
    kpiDaysActive: "Jours Actifs",
    kpiDaysActiveSubtext: "Depuis le début",
    kpiDaysActiveTooltip: "Nombre total de jours depuis que vous avez commencé à utiliser Hearen.",
    
    kpiTherapyTime: "Temps d'écoute",
    kpiTherapyTimeSubtext: "min aujourd'hui",
    kpiTherapyTimeTooltip: "Durée totale d'écoute effectuée aujourd'hui (ou cette semaine).",
    
    kpiVASPerceived: "VAS (intensité perçue)",
    kpiVASPerceivedSubtext: "(intensité perçue)",
    kpiVASPrevious: "Précédent:",
    kpiVASPerceivedTooltip: "Votre score VAS : échelle subjective d'inconfort de 0 (aucun) à 10 (très fort).",
    
    kpiTinnitusPitch: "Fréquence Acouphènes",
    kpiTinnitusPitchSubtext: "Votre fréquence actuelle",
    kpiTinnitusPitchTooltip: "La hauteur dominante de vos acouphènes, mesurée en Hertz (Hz).",
    
    // Graphs
    therapyMinutesPerDayDesc: "Durée totale des sessions d'écoute effectuées chaque jour.",
    therapyMinutesRecommendation: "Cible quotidienne recommandée : 15 minutes",
    
    tinnitusImpactScore: "Score d'Impact des Acouphènes",
    tinnitusImpactScoreDesc: "Votre score d'impact quotidien (0 = faible, 100 = élevé), basé sur vos propres données déclarées.",
    tinnitusImpactScoreWarning: "Ce score reflète votre gêne quotidienne liée à l'acouphène, selon votre ressenti. Il n'est pas lié à votre temps d'écoute.",
    tinnitusImpactTooltip: "Ce graphique affiche uniquement la gêne que vous déclarez vous-même, jour après jour. Il n'intègre ni les minutes d'écoute ni aucun calcul automatique. Chaque point correspond exactement à ce que vous avez sélectionné lorsque vous avez évalué vos acouphènes ce jour-là. La ligne de tendance (optionnelle) sert simplement à visualiser l'évolution générale.",
    
    // Variations info
    variationsInfoShort: "Les variations quotidiennes sont normales. Concentrez-vous sur la tendance globale.",
    tooltipVariationsTitle: "Les variations quotidiennes sont normales",
    tooltipVariationsText: "Vos acouphènes peuvent varier d'un jour à l'autre — c'est normal. Ces fluctuations dépendent souvent du stress, du sommeil, de la fatigue, de l'attention ou du bruit ambiant. L'important est la tendance globale sur plusieurs jours, pas la valeur d'un jour isolé.",
    onboardingVariationsText: "Vos acouphènes peuvent fluctuer d'un jour à l'autre : c'est tout à fait normal. Le tableau de bord met surtout en avant votre évolution globale.",
    ok: "OK",
    showTrendline: "Afficher la ligne de tendance",
    impactScore: "Impact",
    trendline: "Tendance",
    
    progressBannerExplain: "Hearen suit deux types de données distinctes : votre activité d'écoute (objective) et votre perception de l'acouphène (subjective). Ces indicateurs ne sont pas liés entre eux.",
    
    sectionTherapyActivity: "Votre Activité d'écoute",
    sectionTherapyActivityDesc: "Données objectives : vos sessions d'écoute et le temps passé",
    sectionTinnitusPerception: "Votre Perception de l'Acouphène",
    sectionTinnitusPerceptionDesc: "Données subjectives : comment vous ressentez vos acouphènes",
    
    // Tinnitus Impact Score - Interpretive Summary v1.2
    summaryImproving: "En amélioration",
    summaryImprovingText: "Votre impact moyen des acouphènes diminue cette semaine (-{percentage}%).",
    summaryStable: "Stable",
    summaryStableText: "Votre perception des acouphènes est relativement stable cette semaine.",
    summaryIncreasing: "En augmentation",
    summaryIncreasingText: "Votre impact des acouphènes est plus élevé cette semaine (+{percentage}%).",
    
    // Graph Legend
    legendDailyImpact: "Impact quotidien",
    legendTrendline: "Tendance",
    legendMovingAvg: "Moyenne 7 jours",
    legendPurpleLine: "Ligne violette :",
    legendPurpleDesc: "vos données auto-déclarées d'impact quotidien (0 = faible, 100 = élevé)",
    legendBlueLine: "Ligne bleue pointillée :",
    legendBlueDesc: "tendance générale (aide à visualiser la progression globale)",
    legendGreyLine: "Ligne grise claire :",
    legendGreyDesc: "moyenne glissante sur 7 jours",
    therapyMinutesPerDay: "Minutes d'écoute par jour",
    dailyScore: "Score quotidien",
    audiometricEvolution: "Évolution audiométrique",
    audiogramComparison: "Comparaison entre le premier test (ligne pointillée) et le dernier (ligne pleine)",
    insightsTitle: "Observations & Recommandations",
    loading: "Chargement...",
    noData: "Aucune donnée disponible. Effectuez des tests et des sessions d'écoute pour voir vos progrès.",
    duration: "Durée",
    baselineLeft: "Baseline Gauche",
    baselineRight: "Baseline Droite",
    currentLeft: "Actuel Gauche",
    currentRight: "Actuel Droite",
    progressTitle: "Progrès",
    yourProgress: "Votre Progression",
    weeklyOverview: "Vue d'ensemble hebdomadaire",
    monthlyTrend: "Tendance mensuelle",
    downloadReport: "Télécharger le rapport",
    noDataAvailable: "Aucune donnée disponible. Complétez des tests et des sessions d'écoute pour voir vos progrès.",
    insightsRecommendations: "Aperçus et Recommandations",
    makingProgress: "Vous progressez - Continuez !",
    positiveEvolution: "Évolution positive",
    pdfExportSoon: "Export PDF bientôt disponible",
    comparisonFirstLatest: "Comparaison entre le premier test (ligne pointillée) et le plus récent (ligne pleine)",
    
    // AudiometricTest.js
    audiometricTestTitle: "Test Audiométrique",
    audiometricInstructions: "Portez un casque (AirPods recommandés) et ajustez le volume confortablement",
    selectEar: "Sélectionnez l'oreille à tester",
    nextFrequency: "Fréquence suivante",
    yourResults: "Vos résultats",
    threshold: "Seuil",
    volumeAdjustment: "Ajustement du volume pour cette fréquence",
    
    // TinnitusTest.js
    tinnitusTestTitle: "Test d'Identification des Acouphènes",
    tinnitusInstructions: "Trouvez la fréquence qui correspond le mieux à votre acouphène",
    adjustFrequency: "Ajustez la fréquence",
    adjustVolume: "Ajustez le volume",
    stopFrequency: "Arrêter",
    closeMatch: "Proche",
    exactMatch: "Exact",
    finishTest: "Terminer",
    tinnitusCharacteristics: "Caractéristiques de l'acouphène",
    detectedFrequency: "Fréquence détectée",
    perceivedVolume: "Volume perçu",
    tinnitusVolumeDesc: "Volume perçu en dB SPL - Objectif : diminution au fil du temps",
    tinnitusFrequencyDesc: "Fréquence détectée en Hz au fil du temps",
    
    // V1.1: Free/Premium Limits
    favoritesLimitReached:
      "Vous pouvez enregistrer davantage de favoris avec Hearen Premium.",
    playlistLimitReached:
      "Hearen Premium permet de créer plusieurs playlists.",
    limitReached:
      "Disponible avec Hearen Premium",
    
    // Calibration.js
    calibrationSubtitle: "Étape essentielle avant les tests",
    disclaimerTitle: "Important - Limitations et usage approprié",
    disclaimerWarning: "HEAREN est un outil complémentaire de bien-être, UN OUTIL DE BIEN-ÊTRE.",
    whatHearenCanDo: "Ce que HEAREN peut faire :",
    canDo1: "Évaluation indicative de votre profil auditif",
    canDo2: "Personnalisation de l'écoute",
    canDo3: "Suivi de votre progression",
    methodology: "Méthodologie :",
    methodologyDesc: "Basée sur ISO 389-8 et ISO 8253-1 (avec adaptations pour environnement non-clinique)",
    consultORL: "En cas d'acouphènes, consultez TOUJOURS un médecin ORL",
    understoodContinue: "J'ai compris, continuer",
    calibrationTitle: "Calibration du casque (AirPods recommandés)",
    calibrationDesc: "Configuration professionnelle pour des résultats fiables",
    calibrationImportant: "La calibration garantit des résultats précis et cohérents",
    calibrationPrerequisites: "Pré-requis matériel :",
    headphoneRecommended: "Casque recommandé (AirPods recommandés) :",
    headphoneDesc: "Circum-aural (couvre-oreille) ou intra-auriculaire de qualité",
    quietEnvironment: "Environnement :",
    quietEnvironmentDesc: "Pièce calme, sans bruit de fond",
    systemVolume: "Volume système :",
    systemVolumeDesc: "Réglez le volume à 100% (le test ajustera automatiquement)",
    calibrationSteps: "Étapes de calibration :",
    calibrationStep1: "Vérification spatialisation (gauche/droite)",
    calibrationStep2: "Calibration multi-fréquences (500, 1000, 4000 Hz)",
    calibrationStep3: "Validation de la cohérence",
    calibrationWarning: "Important : Ne modifiez pas le volume après la calibration",
    startCalibration: "Commencer la calibration",
    spatialTestTitle: "Étape 1 : Vérification spatialisation",
    spatialTestDesc: "Vérifiez que votre casque (AirPods recommandés) fonctionne correctement",
    spatialInstructions: "Écoutez les sons et confirmez que vous entendez dans la bonne oreille :",
    testLeft: "Tester oreille gauche",
    testRight: "Tester oreille droite",
    testBoth: "Tester les deux",
    stop: "Arrêter",
    continueToMultiFreq: "Continuer vers calibration multi-fréquences",
    multiFreqTitle: "Étape 2 : Calibration multi-fréquences",
    multiFreqDesc: "Calibration des niveaux sonores sur différentes fréquences",
    currentFrequency: "Fréquence actuelle",
    currentLevel: "Niveau actuel",
    confirmation: "Confirmation",
    multiFreqInstructions: "Cliquez 'J'entends' dès que vous percevez le son. Le volume augmente automatiquement toutes les 2 secondes.",
    iHear: "J'entends",
    stopSound: "Stopper le son",
    completedFrequencies: "Fréquences complétées :",
    calibrationComplete: "Calibration terminée",
    calibrationGood: "✓ Calibration de bonne qualité",
    calibrationGoodDesc: "Les résultats sont cohérents entre les différentes fréquences.",
    calibrationWarningTitle: "⚠️ Cohérence modérée",
    calibrationWarningDesc: "Les seuils varient entre les fréquences. Résultats utilisables mais environnement peut être bruyant.",
    calibrationResults: "Résultats de calibration :",
    calibrationOffset: "Offset de calibration",
    startTest: "Commencer le test audiométrique",
    calibrationTooLoud: "Niveau trop élevé atteint. Vérifiez votre casque (AirPods recommandés) et le volume système.",
    autoDetectionUnavailable: "ℹ️ Détection automatique non disponible. Assurez-vous d'utiliser un casque de qualité (AirPods recommandés).",
    retry: "🔄 Réessayer",
    bluetoothHeadphoneDetected: "✓ Casque Bluetooth (AirPods recommandés) détecté",
    step1Title: "Mettez votre casque (AirPods recommandés)",
    step1Desc: "Assurez-vous qu'il est bien positionné",
    step2Title: "Écoutez le son de référence",
    step2Desc: "Cliquez sur 'Jouer' ci-dessous",
    step3Title: "Ajustez le volume",
    step3Desc: "Le son doit être audible mais confortable",
    tooQuiet: "Trop faible",
    perfect: "Parfait",
    tooLoud: "Trop fort",
    goToTests: "Aller aux tests",
    whyCalibrate: "Pourquoi calibrer ?",
    calibrationExplanation: "La calibration garantit que tous les tests sont effectués avec un volume de référence précis et confortable pour votre audition.",
    
    // Tests.js & AudiometricTest.js
    testsSubtitle: "Évaluez votre audition et vos acouphènes",
    progressSubtitle: "Analysez votre évolution vers le silence",
    backToSelection: "Retour au choix",
    completeAudioTestDesc: "Test audiométrique complet avec calibrage professionnel",
    testCharacteristics: "Caractéristiques du test",
    sevenFrequencies: "7 fréquences testées (125Hz - 8000Hz)",
    separateEarTest: "Test pour chaque oreille séparément",
    testDuration: "Durée : ~10-15 minutes",
    complianceNote: "Note de conformité :",
    hearenNoMedicalData: "HEAREN ne collecte pas de données de bien-être. Les tests intégrés sont conçus pour une auto-évaluation bien-être et ne remplacent pas un avis clinique.",
    therapySubtitle: "Paysages sonores personnalisés",
    playlistsSubtitleHome: "Vos sessions favorites",
    radioSubtitleHome: "Canaux thématiques",
    historySubtitle: "Vos résultats de tests",
    sosSubtitleHome: "Apaisement immédiat",
    wellnessStatement: "HEAREN est une application de bien-être auditif, conçue pour vous aider à retrouver équilibre et confort sonore au quotidien.",
    calibrationStatus: "Statut",
    calibrated: "Calibré",
    notCalibrated: "Non calibré",
    never: "Jamais",
    testsImportant: "Les tests sont essentiels",
    testsImportantDesc: "Ils permettent de personnaliser précisément votre expérience sonore pour obtenir les meilleurs résultats",
    
    // SOS.js
    sosSubtitle: "En cas de crise d'acouphènes intense",
    howAreYouFeeling: "Comment vous sentez-vous ?",
    veryCritical: "Critique",
    difficult: "Difficile",
    manageable: "Gérable",
    quickReliefTitle: "Calme immédiat",
    quickReliefDesc:
      "Sons apaisants pour créer un environnement d’écoute plus doux",
    contactSupportDesc: "Aide professionnelle disponible 24/7",
    emergencyTitle: "Besoin d'aide ?",
    emergencyDesc: "Si vous avez besoin d'aide, contactez un professionnel de santé",
    callEmergency: "Contacter un professionnel",
    sosHelp: "Nous sommes là pour vous",
    sosHelpDesc: "Prenez quelques minutes pour vous calmer. Tout ira bien.",
    
    // SOSCalm.js
    sosCalmSubtitle: "Technique de cohérence cardiaque",
    breathingExercise: "Exercice de Respiration",
    cycleCount: "Cycle",
    feelingBetter: "Vous sentez-vous mieux ?",
    backToSOS: "Retour",
    exerciseBenefits: "Bienfaits",
    benefitCalm: "Réduit le stress et l'anxiété",
    benefitHeartRate: "Régule le rythme cardiaque",
    benefitFocus: "Améliore la concentration",
    
    // RadioHearen.js
    radioSubtitle: "Programmes continus d'écoute",
    upNext: "À suivre",
    nowPlaying: "En cours",
    endSession: "Fin de session",
    // Radio channel labels (NO "Radio" prefix - context is clear from screen)
    channelFocus: "Focus",
    channelFocusDesc: "Concentration et productivité",
    channelRelax: "Relaxation",
    channelRelaxDesc: "Détente et relaxation",
    channelSleep: "Sommeil",
    channelSleepDesc: "Pour un sommeil réparateur",
    channelNature: "Nature",
    channelNatureDesc: "Sons naturels apaisants",
    channelChill: "Chill / Lofi",
    channelChillDesc: "Ambiances douces et modernes",
    channelNoise: "Bruits",
    channelNoiseDesc: "Bruits blancs et textures",
    channelPulseFlow: "Pulse Flow",
    channelPulseFlowDesc: "Une énergie moderne, maîtrisée et harmonieuse — signée Hearen.",
    channelClassical: "Classique",
    channelClassicalDesc: "Musique classique apaisante",
    channelMeditation: "Méditation",
    channelMeditationDesc: "Accompagnement méditatif",
    listeningTime: "Temps d'écoute",
    listeners: "auditeurs",
    
    // CustomSounds.js
    customSoundsSubtitle: "Importez vos propres fichiers audio",
    uploadInstructions: "Formats acceptés : MP3, WAV, OGG, FLAC",
    maxFileSize: "Taille maximale : 50 MB",
    selectFile: "Sélectionner un fichier",
    uploading: "Téléchargement en cours...",
    uploadSuccess: "Son téléchargé avec succès",
    uploadError: "Erreur lors du téléchargement",
    soundDeleted: "Son supprimé avec succès",
    
    // Playlists.js
    playlistsSubtitle: "Créez des séquences personnalisées",
    playlistName: "Nom de la playlist",
    addSounds: "Ajouter des sons",
    soundsInPlaylist: "Sons dans la playlist",
    removeSoundFromPlaylist: "Retirer de la playlist",
    deletePlaylist: "Supprimer la playlist",
    playlistSaved: "Playlist enregistrée",
    playlistDeleted: "Playlist supprimée",
    editPlaylist: "Modifier la playlist",
    playPlaylist: "Lire la playlist",
    shufflePlaylist: "Lecture aléatoire",
    loopPlaylist: "Lecture en boucle",
    
    // GetStarted.js
    welcomeToHearen: "Bienvenue sur Hearen",
    yourJourneyStarts: "Votre parcours vers le bien-être auditif commence ici",
    step1Action: "Calibrer maintenant",
    step2Action: "Faire les tests",
    step3Action: "Démarrer l'écoute",
    whyTheseSteps: "Pourquoi ces étapes ?",
    stepsExplanation: "Ces étapes permettent de personnaliser précisément votre expérience sonore pour obtenir les meilleurs résultats.",
    skipForNow: "Passer pour le moment",
    alreadyCompleted: "Déjà complété",
    
    // Onboarding
    lessThan3Months: "Moins de 3 mois",
    threeToSixMonths: "3 à 6 mois",
    sixToTwelveMonths: "6 mois à 1 an",
    moreThanOneYear: "Plus d'un an",
    bothEars: "Les deux",
    fluctuating: "Variable",
    highPitchRinging: "Sifflement aigu",
    highPitchDesc: "Son aigu continu (8000-12000 Hz)",
    lowHumming: "Bourdonnement grave",
    lowHummingDesc: "Son grave et profond (100-250 Hz)",
    clickingCracking: "Clic/Craquement",
    clickingDesc: "Sons secs et répétitifs",
    pulsatileBeating: "Pulsatile (battement)",
    pulsatileDesc: "Battement rythmique synchronisé",
    modulatedWhistle: "Sifflement modulé",
    modulatedDesc: "Son qui varie en intensité",
    whiteNoiseStatic: "Bruit blanc/Statique",
    whiteNoiseDesc: "Bruit de fond continu type 'radio'",
    otherDesc: "Type différent des descriptions ci-dessus",
    question: "Question",
    howLongTinnitus: "Depuis combien de temps ressentez-vous votre acouphène ?",
    whichSideTinnitus: "De quel côté ressentez-vous votre acouphène ?",
    whatYouWillGet: "Ce que vous allez obtenir",
    benefit1: "Des paysages sonores adaptés à vos besoins",
    benefit2: "Un parcours personnalisé selon votre profil",
    benefit3: "Des recommandations ciblées pour votre bien-être",
    importantInformation: "Information importante",
    consentText: "Je comprends qu'HEAREN est une application de bien-être et d'éducation sonore, un outil de bien-être.",
    importantWarning: "Avertissement important",
    disclaimerText: "HEAREN est une application de bien-être et d'éducation sonore. Elle ne remplace pas un avis professionnel. En cas de symptômes nouveaux, violents, ou d'acouphènes pulsatiles, consultez un professionnel de santé.",
    close: "Fermer",
    timeEstimate: "⏱️ Moins de 2 minutes pour personnaliser votre expérience",
    letsSetupProfile: "Configurons votre profil",
    skipOnboarding: "Passer l'introduction",
    nextStep: "Étape suivante",
    previousStep: "Étape précédente",
    completeSetup: "Terminer la configuration",
    setupComplete: "Configuration terminée !",
    startUsingHearen: "Commencer à utiliser Hearen",
    whatIsHearen: "Qu'est-ce que Hearen ?",
    hearenDescription: "Hearen est une application d'écoute conçue pour soulager les acouphènes et améliorer votre confort auditif au quotidien.",
    letsBegin: "Commençons",
    constantly: "En permanence",
    rarely: "Rarement",
    verySevere: "Très sévère",
    mild: "Léger",
    ringing: "Sifflement",
    hissing: "Sifflement aigu",
    clicking: "Cliquetis",
    impactSleep: "Sommeil",
    impactConcentration: "Concentration",
    impactMood: "Humeur",
    impactSocial: "Vie sociale",
    impactWork: "Travail",
    notAtAll: "Pas du tout",
    aLittle: "Un peu",
    quite: "Assez",
    extremely: "Extrêmement",
    haveSeenSpecialist: "Avez-vous consulté un spécialiste ?",
    specialistType: "Type de spécialiste",
    ent: "ORL",
    audiologist: "Audiologiste",
    psychologist: "Psychologue",
    currentMedications: "Médicaments actuels",
    previousTherapies: "Approches essayées",
    hearingAids: "Appareils auditifs",
    acupuncture: "Acupuncture",
    preferredLanguage: "Langue préférée",
    notificationPreferences: "Notifications",
    enableNotifications: "Activer les notifications",
    dailyReminders: "Rappels quotidiens",
    progressUpdates: "Mises à jour de progression",
    therapyPreferences: "Préférences d'écoute",
    preferredSoundCategory: "Catégorie de sons préférée",
    themePreference: "Thème de l'application",
    lightTheme: "Clair",
    darkTheme: "Sombre",
    autoTheme: "Automatique",
    
    audioProfileDescription:
      "Votre écoute s’adapte en temps réel pour plus de confort.",

    // Home page
    welcome: "Bienvenue sur Hearen",
    welcomePersonalized: "Bonjour",
    welcomeBack: "Bonjour",
    welcomeSubtitle: "Écoute personnalisée pour acouphènes",
    dashboardSubtitle: "Votre espace de écoute personnalisée",
    homeSubtitle: "Votre tableau de bord personnalisé",
    homeHeroTitle: "Entrez dans le calme",
    homeHeroSubtitle: "Un geste. Un espace infini.",
    chooseExperience: "Choisissez votre expérience",
    discoverHearenBadge: "✨ Découvrir Hearen",
    useHeadphones: "Utilisez un casque (AirPods recommandés) pour de meilleurs résultats",
    getStarted: "Commencer",
    aboutTitle: "À propos de Hearen",
    aboutDesc: "Hearen vous aide à gérer vos acouphènes grâce à des tests auditifs et une écoute personnalisée.",
    yourResults: "Vos résultats",
    notCompleted: "Non effectué",
    view: "Voir",
    start: "Démarrer",
    nextStep: "Prochaine étape",
    completeAudiometric: "Effectuez le test audiométrique pour personnaliser votre écoute.",
    completeTinnitus: "Effectuez le test acouphènes pour un traitement ciblé.",
    testsComplete: "Tests complétés",
    readyForTherapy: "Vous pouvez maintenant profiter d'une écoute personnalisée adaptée à votre profil.",
    startTherapy: "Démarrer l'écoute",
    
    // New Home Components
    coachTitle: "Votre Coach Personnel",
    coachDescription: "Suivez votre plan personnalisé et évaluez vos progrès quotidiens",
    viewPlan: "Voir mon plan",
    startConversation: "Démarrer une conversation",
    
    // Daily Check-in (Redirect to Coach)
    evaluateTinnitusToday: "Évaluez vos acouphènes aujourd'hui",
    openCoachToRate: "Ouvrez le Coach pour noter l'intensité du jour",
    moodGood: "Bien",
    moodOkay: "Moyen",
    moodBad: "Difficile",
    
    // Therapy Tiles
    therapyAccess: "Paysages sonores",
    radio: "Presence",
    radioDesc: "Programmes guidés",
    therapyDesc: "Séances personnalisées",
    sos: "Apaisement rapide",
    sosDesc: "Apaisement rapide",
    
    // Progress Summary
    yourProgress: "Vos Progrès",
    seeAll: "Voir tout",
    totalTime: "Temps total",
    sessions: "Sessions",
    streak: "Série active",
    progressNote: "Consultez votre page Progrès pour les détails complets",
    weekSummary: "séances cette semaine",
    minShort: "min",
    
    // Tools Tiles
    toolsAndTests: "Outils & Tests",
    explore: "Explorer",
    yourSpace: "Votre Espace",
    
    // Profile Page
    labTitle: "Mode Lab (Expérimental)",
    labBeta: "Bêta",
    labDescription: "Programmes expérimentaux Notch/Inverse",
    adminTitle: "Administration",
    adminDescription: "Bibliothèque & Messages Vocaux",
    resetOnboarding: "Réinitialiser Onboarding (Test)",
    viewOnboarding: "Voir l'Onboarding",
    confirmReset: "Confirmer la réinitialisation",
    confirmResetMessage: "Voulez-vous vraiment réinitialiser votre profil onboarding ? Vous pourrez refaire le questionnaire complet.",
    yesReset: "Oui, réinitialiser",
    cancel: "Annuler",
    resetting: "Réinitialisation...",
    changePassword: "Changer le mot de passe",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    updatePassword: "Mettre à jour",
    passwordUpdated: "Mot de passe mis à jour avec succès",
    passwordError: "Erreur lors de la mise à jour du mot de passe",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    
    // History Page
    therapySessions: "Sessions d'écoute",
    therapyHistory: "Historique de vos séances",
    therapyHistoryDesc: "Historique de vos sessions d'écoute",
    totalSessions: "Sessions totales",
    favoriteTherapy: "Écoute préférée",
    incomplete: "Incomplet",
    therapyAdjustment: "Ajustement sonore",
    learnMore: "En savoir plus",
    therapyMethodExplained: "🎯 Méthode sonore",
    therapyPhilosophy: "Il ne s'agit pas d'éteindre le son. Il s'agit d'apprendre à le faire disparaître naturellement.",
    audiometricTests: "Tests Audiométriques",
    testsDesc: "Évaluez votre audition",
    testsHomeDesc: "Évaluez votre audition",
    assistant: "Assistant IA",
    assistantDesc: "Posez vos questions",
    assistantHomeDesc: "Posez vos questions",
    guideDesc: "Comprendre l'écoute",
    guideHomeDesc: "Comprendre l'approche",
    settingsDesc: "Personnalisation",
    settingsHomeDesc: "Personnalisation",
    sosCalm: "SOS Calm",
    sosCalmDesc: "Apaisement immédiat",
    settings: "Paramètres",
    
    // Tests page
    tests: "Tests",
    testsSubtitle: "Évaluez votre audition et vos acouphènes",
    calibration: "Calibration",
    calibrationDesc: "Vérification du matériel et réglage de la spatialisation",
    calibrationBundle: "Calibration & test auditif",
    calibrationBundleDesc: "Réglage de votre écoute puis mesure de votre audition",
    audiometricTestDesc: "Laissez Hearen s’adapter progressivement à votre perception.",
    tinnitusTestDesc: "Identifiez la tonalité qui se rapproche le plus de votre perception des acouphènes pour personnaliser votre environnement sonore.",
    testsInfo: "Ces étapes aident Hearen à personnaliser votre environnement sonore.",
    
    // Hearing Knowledge
    hearingKnowledgeTitle: "Connaître votre audition",
    hearingKnowledgeIntro:
      "Votre audition est unique. Hearen peut commencer à la comprendre de deux façons.",

    exploreMyHearing: "Explorer mon écoute",
    exploreMyHearingDesc:
      "Choisissez comment Hearen peut commencer à comprendre votre audition.",

    startHearingTest: "Réaliser un test auditif Hearen",
    startHearingTestDesc:
      "Explorer votre écoute directement dans l’application.",

    readClinicalAudiogram: "Lire un audiogramme clinique",
    readClinicalAudiogramDesc:
      "Utiliser un audiogramme réalisé par un professionnel.",

    viewHistoryDesc:
      "Retrouver vos anciens résultats et suivre votre trajectoire.",

    hearingKnowledgeFooter:
      "Les deux approches permettent ensuite à Hearen de personnaliser votre expérience d’écoute.",
    // Guide
    guide: "Guide",
    
    // Authentication
    loginTitle: "Connexion",
    loginDesc: "Connectez-vous à votre compte Hearen",
    forgotPassword: "Mot de passe oublié ?",
    forgotPasswordPage: {
      title: "Mot de passe oublié",
      intro: "Entrez votre adresse email pour recevoir un lien de réinitialisation.",
      placeholder: "votre@email.com",
      submit: "Envoyer le lien de réinitialisation",
      loading: "Envoi…",
      back: "Retour à la connexion",
      success: "Si un compte correspond à cette adresse, un email de réinitialisation a été envoyé.",
      requestError: "Impossible d'envoyer la demande pour le moment. Veuillez réessayer.",
      genericError: "Une erreur est survenue. Veuillez réessayer."
    },
    resetPassword: {
      subtitle: "Réinitialisation du mot de passe",
      title: "Choisir un nouveau mot de passe",
      hint: "Votre nouveau mot de passe doit contenir au moins 8 caractères.",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      submit: "Modifier mon mot de passe",
      loading: "Modification…",
      successTitle: "Mot de passe modifié",
      successMessage: "Votre mot de passe a été modifié.",
      successReturn: "Vous pouvez maintenant retourner dans Hearen et vous connecter avec votre nouveau mot de passe.",
      invalidLink: "Ce lien de réinitialisation est invalide.",
      expiredLink: "Ce lien de réinitialisation est invalide ou a expiré.",
      mismatch: "Les deux mots de passe ne correspondent pas.",
      tooShort: "Le mot de passe doit contenir au moins 8 caractères.",
      genericError: "Une erreur est survenue. Veuillez réessayer.",
      changeError: "Impossible de modifier le mot de passe."
    },
    registerTitle: "Inscription",
    registerDesc: "Créez votre compte Hearen",
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    firstName: "Prénom",
    lastName: "Nom",
    login: "Se connecter",
    register: "S'inscrire",
    logout: "Déconnexion",
    connectedAs: "Connecté en tant que",
    loading: "Chargement...",
    noAccount: "Pas encore de compte ?",
    hasAccount: "Déjà un compte ?",
    loginLink: "Se connecter",
    registerLink: "S'inscrire",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
    language: "fr",
    
    // Audiometric Test
    audiometricTitle: "Test Audiométrique",
    audiometricDesc: "Évaluez votre audition à différentes fréquences (ou importez votre test professionnel)",
    selectEar: "Sélectionnez l'oreille",
    leftEar: "Oreille gauche",
    rightEar: "Oreille droite",
    bothEars: "Les deux",
    incomplete: "Incomplet",
    startTest: "Démarrer le test",
    iHear: "J'entends",
    nextFrequency: "Fréquence suivante",
    testComplete: "Test terminé !",
    saveResults: "Enregistrer les résultats",
    testing: "Test en cours...",
    testInProgress: "Test audiométrique en cours",
    currentVolume: "Volume actuel",
    stopTest: "Arrêter le test",
    
    // Calibration
    calibrationTitle: "Calibration du casque (AirPods recommandés)",
    calibrationDesc: "Avant de commencer le test audiométrique, nous devons calibrer votre casque (AirPods recommandés)",
    calibrationImportant: "La calibration garantit des résultats précis et cohérents",
    calibrationSteps: "Étapes de calibration :",
    calibrationStep1: "Vérifier la spatialisation (gauche/droite)",
    calibrationStep2: "Ajuster le volume système à un niveau confortable",
    calibrationStep3: "Valider que le son de référence (25 dB HL) est clairement audible",
    calibrationWarning: "Important : Ne modifiez pas le volume de votre ordinateur après la calibration",
    startCalibration: "Commencer la calibration",
    spatialTestTitle: "Étape 1 : Vérification de la spatialisation",
    spatialTestDesc: "Vérifiez que votre casque (AirPods recommandés) est correctement positionné",
    spatialInstructions: "Écoutez les sons suivants et confirmez que vous entendez bien dans la bonne oreille :",
    testLeft: "Tester oreille gauche",
    testRight: "Tester oreille droite",
    testBoth: "Tester les deux",
    continueToVolumeCalibration: "Continuer vers la calibration du volume",
    volumeCalibrationTitle: "Étape 2 : Calibration du volume",
    volumeCalibrationDesc: "Ajustez le volume jusqu'à entendre clairement le son de référence",
    referenceSound: "Son de référence : 25 dB HL",
    referenceSoundDesc: "Ce son représente un chuchotement ou une conversation très faible. Il doit être clairement audible mais pas fort.",
    playReferenceSound: "Jouer le son de référence",
    adjustSystemVolume: "Modifier le volume d'écoute au seuil minimum auquel vous percevez le son :",
    calibrationSliderDesc: "Utilisez aussi ce curseur pour un ajustement fin :",
    calibrationReady: "Une fois le son clairement audible et confortable, validez la calibration",
    validateCalibration: "Valider et commencer le test",
    back: "Retour",
    stop: "Arrêter",
    
    // Tinnitus Test
    tinnitusTitle: "Test Acouphène",
    tinnitusDesc: "Identifiez la fréquence de votre acouphène",
    step1: "Étape 1 : Recherche large",
    step2: "Étape 2 : Affinement",
    matchesMyTinnitus: "Ça correspond !",
    adjustFrequency: "Ajustez la fréquence",
    currentFrequency: "Fréquence actuelle",
    detectedFrequency: "Fréquence détectée",
    adjustVolumeForTherapy: "Ce volume doit couvrir précisément votre acouphène, il sera utilisé pour votre écoute personnalisée",
    volumeLevel: "Niveau sonore",
    volumeInstruction: "Ajustez avec précision pour correspondre au volume de votre acouphène (paliers de 0.5 dB)",
    
    // Therapy
    therapyTitle: "Paysages sonores",
    therapeuticSound: "Son apaisant",
    therapyDesc: "Écoutez des paysages sonores personnalisés",
    soundCategory: "Catégorie de sons",
    sound: "Son",
    selectCategory: "Catégorie de son",
    selectSound: "Choisir un son",
    playlistSounds: "Sons de la playlist",
    chooseSound: "Sélectionnez un son...",
    selectTherapyType: "Type d'écoute",
    inverseNotch: "Inverse Notch",
    pinkNoise: "Bruit Rose",
    brownNoise: "Bruit Brun",
    whiteNoise: "Bruit Blanc",
    natureSounds: "Sons de la Nature",
    musicalStyles: "Styles musicaux",
    play: "Lecture",
    pause: "Pause",
    stop: "Arrêter",
    volume: "Volume",
    duration: "Durée",
    minutes: "minutes",
    sessionTime: "Temps de session",
    personalizedEqualizer: "Égaliseur personnalisé",
    audiometricCompensation: "Compensation audiométrique",
    audiometricCompensationDesc: "Ajuste le volume selon vos pertes auditives",
    audiometricCompensationDescInactive: "Effectuez un test audiométrique pour activer",
    tinnitusTherapy: "Écoute Acouphènes (Inverse Notch)",
    tinnitusTherapyDescActive: "Boost adaptatif",
    tinnitusTherapyDescInactive: "Effectuez un test acouphènes pour activer",
    soundWillRestart: "Le son sera automatiquement redémarré avec les nouveaux réglages",
    performTestsToActivate: "Effectuez les tests audiométrique et acouphènes pour activer ces fonctionnalités",
    audioProcessing: "Traitement audio",
    equalizerLabel: "Égaliseur audiométrique",
    notchLabel: "Acouphènes",
    tinnitusLabel: "Acouphènes",
    frequenciesCompensated: "fréquences compensées",
    selectSoundAlert: "Veuillez sélectionner un son",
    errorPlayingSound: "Erreur lors de la lecture du son",
    errorSavingSession: "Erreur lors de l'enregistrement de la session",
    errorToggleFavorite: "Erreur lors de l'ajout aux favoris",
    
    // ===== CANONICAL THEMES (SINGLE SOURCE OF TRUTH) =====
    // Used by Radio, Soundscapes, Playlists - DO NOT ADD "Radio" TO LABELS
    themes: {
      nature: "Nature",
      relaxation: "Relaxation",
      sleep: "Sommeil",
      meditation: "Méditation",
      pulseFlow: "Pulse Flow",
      classical: "Classique",
      chillLofi: "Chill / Lofi",
    },
    
    // Therapy categories (legacy - prefer themes.* for new code)
    categoryNature: "Nature",
    categoryRelaxation: "Relaxation",
    categorySleep: "Sommeil",
    categoryFocus: "Focus",
    categoryNoise: "Bruits",
    categoryTones: "Tons purs",
    categoryMySounds: "Mes sons",
    categoryFavorites: "Favoris",
    noSoundsInCategory: "Aucun son disponible dans cette catégorie",
    addToFavorites: "Ajouter aux favoris",
    removeFromFavorites: "Retirer des favoris",
    
    // Legacy categories (keep for compatibility)
    categoryClassique: "Musique Classique",
    categoryJazz: "Jazz",
    categoryAmbiance: "Ambiance",
    categoryChill: "Chill",
    categoryElectro: "Electro",
    noCustomSounds: "Aucun son personnalisé. Uploadez vos sons dans 'Sons Personnalisés'.",
    
    // Nature sounds
    birds: "Oiseaux",
    ocean: "Océan",
    stream: "Ruisseau",
    storm: "Orage",
    
    // Generated sounds
    whiteNoiseName: "Bruit blanc",
    pinkNoiseName: "Bruit rose",
    brownNoiseName: "Bruit brun",
    pureTone440: "Ton pur 440 Hz",
    pureTone1000: "Ton pur 1000 Hz",
    
    // History
    historyTitle: "Historique",
    historyDesc: "Consultez vos résultats et progrès",

    historyAccessTitle: "Accès à mon historique",
    historyAccessDesc: "Retrouvez vos résultats, graphiques et leur évolution dans le temps.",
    viewHistory: "Voir mon historique",

    audiogramHistory: "Historique Audiogrammes",
    audiogramDesc: "Visualisation de vos seuils auditifs par fréquence",
    tinnitusHistory: "Historique Acouphènes",
    tinnitusHistoryDesc: "Fréquences d'acouphènes détectées",
    frequencyEvolution: "Évolution de la fréquence",
    frequencyEvolutionDesc: "Graphique montrant l'évolution de votre acouphène au fil du temps",
    noData: "Aucune donnée disponible",
    date: "Date",
    ear: "Oreille",
    frequency: "Fréquence",
    threshold: "Seuil",
    type: "Type",
    totalSessions: "Sessions totales",
    totalTime: "Temps total",
    testHistory: "Historique des tests",
    frequencies: "fréquences",
    active: "Actif",
    personalized: "personnalisé",
    personalizedListening: "écoute personnalisée (acouphènes)",
    audioProfileLabel: "Profil audio",
    enabled: "Activée",
    confidence: "Confiance",
    therapeuticGain: "Amélioration sonore",
    measuredVolume: "Volume mesuré",
    appliedBoost: "Boost appliqué",
    appliedAttenuation: "Atténuation appliquée",
    therapyPrincipleNotch:
      "Cette approche Notch cible votre fréquence d’écoute afin de créer un environnement sonore plus équilibré et favoriser une écoute plus apaisée au fil du temps.",
    therapyPrincipleInverseNotch:
      "Le boost appliqué cible votre fréquence d’écoute afin d’encourager une adaptation progressive et une écoute plus naturelle. Cette approche reste volontairement douce et vise à accompagner l’habituation au fil du temps.",
    therapyPrinciple:
      "L’approche utilisée privilégie une écoute progressive et confortable afin d’accompagner naturellement votre expérience sonore.",
    lowFrequency: "Grave",
    midFrequency: "Moyen",
    highFrequency: "Aigu",
    veryHighFrequency: "Très aigu",
    favoriteTherapy: "Écoute favorite",

    historyTabAudiogram: "Audiogrammes",
    historyTabTinnitus: "Acouphènes",
    historyTabTherapy: "Séances",

    deleteTestConfirmTinnitus: "Êtes-vous sûr de vouloir supprimer ce test acouphène ?",
    deleteTestConfirmAudiometric: "Êtes-vous sûr de vouloir supprimer ce test audiométrique ?",
    errorDeletingTest: "Erreur lors de la suppression du test",
    tinnitusFrequencyEvolution: "Évolution de la Fréquence des Acouphènes",
    tinnitusVolumeEvolution: "Évolution du Volume des Acouphènes",
    frequencyHz: "Fréquence (Hz)",
    volumeDbSPL: "Volume (dB SPL)",
    frequencyDetectedOverTime: "Fréquence détectée en Hz au fil du temps",
    volumePerceivedOverTime: "Volume perçu en dB SPL - Objectif : diminution au fil du temps",
    severityLow: "Grave",
    severityMedium: "Moyen",
    severityHigh: "Très aigu",
    
    // Professional Audiogram Import
    importProfessionalTest: "Importer un audiogramme clinique",
    importProfessionalDesc: "Capturez votre audiogramme clinique. Hearen l’analysera automatiquement.",
    clickToUpload: "Capturer un audiogramme",
    analyzeWithAI: "Analyser l’audiogramme",
    analyzing: "Analyse en cours...",
    analysisComplete: "Analyse terminée",
    saveTest: "Enregistrer l’audiogramme",
    saving: "Enregistrement...",
    cancel: "Annuler",
    
    customSounds: "Sons Personnalisés",
    customSoundsDesc: "Uploadez vos propres paysages sonores",
    customSoundsTitle: "Sonothèque Personnalisée",
    mySounds: "Mes Sons",
    mySoundsDesc: "Gérez votre bibliothèque de sons personnalisés",
    soundName: "Nom du son",
    enterSoundName: "Entrez un nom...",
    selectFile: "Sélectionner un fichier",
    dragDropOrClick: "Glissez-déposez ou cliquez pour sélectionner",
    upload: "Uploader",
    uploading: "Upload...",
    uploadError: "Erreur lors de l'upload. Veuillez réessayer.",
    nameRequired: "Veuillez donner un nom à votre son.",
    noSounds: "Aucun son personnalisé. Uploadez votre premier son !",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ce son ?",
    confirmDeleteTitle: "Confirmer la suppression",
    confirmDeleteMessage: "Êtes-vous sûr de vouloir supprimer définitivement",
    deleteError: "Erreur lors de la suppression.",
    delete: "Supprimer",
    
    // Playlists
    playlistsTitle: "Mes Playlists",
    playlistsDesc: "Créez et gérez vos playlists personnalisées",
    newPlaylist: "Nouvelle Playlist",
    noPlaylistsMessage: "Aucune playlist. Créez votre première playlist !",
    createPlaylist: "Créer une Playlist",
    soundCount: "son(s)",
    addSound: "Ajouter",
    listen: "Écouter",
    
    // Spectrum Analyzer
    spectrumAnalyzerTitle: "Analyseur de Spectre Professionnel",
    spectrumWillActivate: "L'analyseur de spectre s'activera pendant la lecture",
    levelDbSpl: "Niveau (dB SPL)",
    frequencyHz: "Fréquence (Hz)",
    normalSignal: "Signal Normal",
    audiometricCompensation: "Compensation Audiométrique",
    tinnitusFrequency: "Fréquence Acouphénique",
    
    // Timer
    sessionTimer: "Timer de session",
    unlimited: "Sans limite",
    playbackContinueIndefinitely: "La lecture continuera indéfiniment",
    remaining: "restantes",
    playbackWillStop: "La lecture s'arrêtera progressivement après",
    timerMinutes: "minutes",
    timerOff: "Désactivé",
    startTimer: "Démarrer",
    stopTimer: "Arrêter",
    
    // Audio categories
    classique: "Classique",
    classiqueDesc: "Paysages sonores élégants et apaisants",
    pianoAmbiant: "Ambient",
    pianoAmbiantDesc: "Atmosphères immersives et minimalistes",
    chillLofi: "Chill / Lofi",
    chillLofiDesc: "Textures modernes et douces pour une concentration sereine",
    respiration: "Respiration & Méditation",
    respirationDesc: "Respirez, relâchez",
    nature: "Nature",
    natureDesc: "Ambiances naturelles et apaisantes",
    bruitsTextures: "Bruits & textures",
    bruitsTexturesDesc: "White / Pink / Brown",
    sommeil: "Sommeil",
    sommeilDesc: "Relaxation profonde",
    pulseFlow: "Pulse Flow",
    pulseFlowDesc: "Énergie rythmique moderne pour revitaliser l'esprit",
    focus: "Focus",
    focusDesc: "Concentration sans stress",
    customSounds: "Mes sons",
    customSoundsDesc: "Imports personnels",
    favorites: "Favoris",
    favoritesDesc: "Votre sélection",
    sounds: "sons",
    
    // Common
    left: "Gauche",
    right: "Droite",
    both: "Les deux",
    save: "Enregistrer",
    cancel: "Annuler",
    close: "Fermer",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    hz: "Hz",
    db: "dB",
    
    // Instructions
    useHeadphones: "⚠️ Utilisez un casque (AirPods recommandés) pour de meilleurs résultats",
    adjustVolume: "Ajustez le volume à un niveau confortable",
    listenCarefully: "Écoutez attentivement et cliquez \"J'entends\" dès que vous percevez le son",
    frequencyWillBeUsed: "Cette fréquence sera utilisée pour personnaliser votre expérience sonore",
    moveSliderBroad: "Déplacez le curseur pour trouver approximativement votre fréquence d'acouphène",
    moveSliderFine: "Affinez pour trouver la fréquence exacte",
    adjustUntilMatch: "Ajustez la fréquence jusqu'à ce qu'elle corresponde à votre acouphène",
    continueToTherapy: "Continuer vers l'écoute",
    initialFrequency: "Fréquence initiale",
    personalizedTherapy: "Écoute personnalisée pour",
    noTinnitusDetected: "Aucune fréquence d'acouphène détectée. Effectuez d'abord le test d'acouphène.",
    tip: "💡",
    testInstructions: "Instructions du test :",
    setDeviceVolume100: "Réglez le volume de votre appareil à 100% pour ce test",
    setDeviceVolume100Calibrated: "Réglez le volume de votre appareil au maximum, le niveau du test sera calibré automatiquement",
    autoTestBothEars: "Le test se fait automatiquement sur les deux oreilles",
    eachFreqBothEars: "Pour chaque fréquence : oreille gauche puis oreille droite",
    volumeIncreasesAuto: "Le volume augmente automatiquement de 5 dB HL toutes les 3 secondes",
    clickWhenHear: "Cliquez \"J'entends\" dès que vous percevez le son",
    volumeIncreasesEvery2s: "Le volume augmente automatiquement de 5 dB HL toutes les 3 secondes. Cliquez dès que vous entendez le son.",
    highVolumeWarning: "Niveau élevé atteint",
    autoSkipMessage: "Si vous n'entendez toujours rien, le test passera automatiquement à la prochaine fréquence à 120 dB HL.",
    testVolume: "Volume du test",
    adjustTestVolume: "Ajustez le volume du test selon votre confort (recommandé : 90%)",
    testSpatialAudio: "Test de spatialisation audio",
    testSpatialDesc: "Vérifiez que votre casque (AirPods recommandés) fonctionne correctement en testant chaque oreille :",

    // Guide - User Manual
    guideTitle: "Guide Utilisateur",
    guideSubtitle: "Votre compagnon de rééducation auditive",
    guideImportant: "Important",
    guideImportantText: "HEAREN est une méthode de bien-être complémentaire, axée bien-être. Elle ne remplace pas une accompagnement professionnel. Consultez toujours un médecin ORL en cas d'acouphènes.",
    guideTableOfContents: "Table des matières",
    
    // Philosophy
    guidePhilosophy: "La Philosophie HEAREN",
    guidePhilosophyQuote: "Le cerveau peut réapprendre à entendre autrement",
    guidePhilosophyText: "Les acouphènes ne sont pas une fatalité. Ils résultent souvent d'une désorganisation de la perception auditive, que l'on peut rééquilibrer grâce à la plasticité neuronale.",
    guidePhilosophy5Pillars: "Les 5 Piliers de Notre Méthode",
    
    guidePillar1Title: "Stimulation ciblée et contrôlée",
    guidePillar1Text: "Vous identifiez votre fréquence d'acouphène via un test précis. Un léger renforcement sonore (notch inversé) est appliqué pour favoriser la réorganisation de l'activité auditive corticale.",
    guideNotchExplained: "Le notch inversé expliqué",
    guideNotchExplainedText: "Au lieu de 'couper' votre fréquence d'acouphène, nous la stimulons légèrement pour aider votre cerveau à se réorganiser naturellement.",
    
    guidePillar2Title: "Plasticité neuronale et rééquilibrage",
    guidePillar2Text: "En stimulant la zone hyperactive de façon stable et répétée, le système auditif réapprend à normaliser son activité. L'objectif : réduire progressivement l'intensité et l'intrusion du son perçu.",
    
    guidePillar3Title: "Musique personnalisée, écoute intégrée",
    guidePillar3Text: "La stimulation sonore est délivrée à travers de la vraie musique que vous choisissez. HEAREN renforce subtilement la fréquence ciblée au sein de la musique elle-même.",
    
    guidePillar4Title: "Expérience apaisante et autonome",
    guidePillar4Text: "Vous restez toujours aux commandes : choix des morceaux, intensité, durée. L'écoute devient une pratique apaisante du quotidien.",
    
    guidePillar5Title: "Méthode progressive et non invasive",
    guidePillar5Text: "Aucun médicament, aucun appareil intrusif. Juste une stimulation sonore ciblée, douce et progressive qui accompagne l'oreille et le cerveau.",
    
    // How it works
    guideHowWorks: "Comment ça marche ?",
    guideScienceSimple: "La science en simple",
    guideScienceText: "Votre cerveau est plastique : il peut se réorganiser tout au long de votre vie. Les acouphènes sont souvent le résultat d'une 'désorganisation' dans la façon dont votre cerveau traite les informations auditives.",
    guideScienceText2: "HEAREN utilise cette plasticité pour aider votre cerveau à 'réapprendre' à traiter correctement ces signaux, réduisant ainsi progressivement la perception de l'acouphène.",
    
    guide3Phases: "Les 3 Phases de la Rééducation",
    guidePhase1: "ÉVALUATION",
    guidePhase1Sub: "Votre profil auditif unique",
    guidePhase2: "CALIBRATION",
    guidePhase2Sub: "Personnalisation de l'écoute",
    guidePhase3: "RÉÉDUCATION",
    guidePhase3Sub: "Écoute régulière et progressive",
    
    // Steps
    guideStep1Title: "Étape 1 : Test Audiométrique",
    guideStep1Goal: "Objectif",
    guideStep1GoalText: "Évaluer votre audition sur 7 fréquences clés (125 Hz à 8000 Hz)",
    guideHowItWorks: "Comment ça marche",
    guideStep1Point1: "Calibration du casque (AirPods recommandés)",
    guideStep1Point1Text: "Ajustez le volume de référence (25 dB HL)",
    guideStep1Point2: "Test automatique",
    guideStep1Point2Text: "Le volume augmente progressivement de 5 dB toutes les 3 secondes",
    guideStep1Point3: "Votre rôle",
    guideStep1Point3Text: "Cliquez 'J'entends' dès que vous percevez le son",
    guideStep1Point4: "Résultat",
    guideStep1Point4Text: "Un audiogramme personnalisé des deux oreilles",
    
    guideAdvice: "Conseil",
    guideStep1Tip1: "Utilisez un casque de qualité (AirPods recommandés)",
    guideStep1Tip2: "Installez-vous dans un endroit calme",
    guideStep1Tip3: "Volume système réglé au maximum au départ",
    guideStep1Tip4: "Prenez votre temps, soyez concentré",
    
    guideWhatItProvides: "Ce que ça apporte",
    guideStep1Provides1: "Identifie vos éventuelles pertes auditives",
    guideStep1Provides2: "Permet d'ajuster l'écoute pour compenser ces pertes",
    guideStep1Provides3: "Active la Compensation Audiométrique dans votre expérience",
    
    guideStep2Title: "Étape 2 : Test Acouphènes",
    guideStep2Goal: "Objectif",
    guideStep2GoalText: "Identifier précisément la fréquence de votre acouphène",
    guidePhase1Title: "Phase 1 - Recherche large (500-8000 Hz)",
    guideStep2Phase1Point1: "Déplacez le curseur de fréquence",
    guideStep2Phase1Point2: "Cliquez 'Play' pour écouter",
    guideStep2Phase1Point3: "Ajustez jusqu'à trouver un son similaire",
    guideStep2Phase1Point4: "Cliquez 'Ça correspond !' pour valider",
    guidePhase2Title: "Phase 2 - Affinement (±100 Hz)",
    guideStep2Phase2Point1: "Affinez la fréquence par pas de 10 Hz",
    guideStep2Phase2Point2: "Trouvez la correspondance exacte",
    guideStep2Phase2Point3: "Validez",
    
    guideVolumeAdjustment: "Réglage du volume",
    guideStep2Volume1: "Utilisez le slider 'Niveau sonore' (10-60 dB SPL)",
    guideStep2Volume2: "Important : Ce volume doit couvrir précisément votre acouphène",
    guideStep2Volume3: "Il sera utilisé pour calculer l'intensité de votre expérience",
    
    guideAdaptiveGain: "Atténuation Adaptative Calculée",
    guideBoost: "boost",
    guideAttenuation: "atténuation",
    therapyPoint2Updated: "Calcul automatique de l'atténuation d'écoute (proportionnelle au volume)",
    therapyPoint3Updated: "Application du Notch classique lors de vos sessions d'écoute",
    
    guideStep3Title: "Étape 3 : Paysages Sonores Personnalisés",
    guideStep3Goal: "Objectif",
    guideStep3GoalText: "Rééduquer progressivement votre système auditif",
    therapyMethodTitle: "🎯 Méthode d'écoute",
    howItWorks: "Comment ça fonctionne:",
    therapyPoint1: "Mesure de votre acouphène (volume en dB SPL)",
    therapyPoint2: "Calcul automatique du amélioration sonore (volume ÷ 5)",
    therapyPoint3: "Application du boost lors de vos sessions d'écoute",
    guideTherapyChoice: "Choix du type de son",
    noiseRecommendation: "Nous vous recommandons d'utiliser les bruits blancs, bruns, roses avec modération, leur préférer des sons naturels ou des styles musicaux.",
    guideSpectrumAnalyzer: "Analyseur de Spectre",
    guideSpectrumGreen: "Vert : Fréquences normales",
    guideSpectrumOrange: "Orange : Compensation audiométrique active",
    guideSpectrumRed: "Rouge : Filtre Notch/Inverse Notch sur votre fréquence acouphène",
    
    // Daily usage
    guideDailyUsage: "Utilisation Quotidienne",
    guideBeginner: "Débutant",
    guideBeginnerSessions: "1-2 sessions",
    guideRegular: "Régulier",
    guideRegularSessions: "2-3 sessions",
    guideIntensive: "Intensif",
    guideIntensiveSessions: "Plusieurs sessions",
    
    guideKey: "Clé",
    guideRegularityKey: "La régularité est plus importante que la durée. Mieux vaut 20 min chaque jour que 2h une fois par semaine.",
    
    guideBestTime: "Meilleur moment",
    guideMorning: "Matin : Commencez la journée de façon apaisante",
    guideLunch: "Pause déjeuner : Moment de relaxation",
    guideEvening: "Fin de journée : Décompression après le travail",
    guideBedtime: "Avant de dormir : Facilite l'endormissement",
    
    guideGoldenRule: "Règle d'or",
    guideGoldenRuleText: "Le son apaisant doit être confortable, jamais inconfortable.",
    
    // What to expect
    guideWhatToExpect: "À Quoi S'Attendre",
    guideWeek12: "Semaine 1-2 : ADAPTATION",
    guideWeek12Text: "Vous vous familiarisez avec l'application. Pas de changement notable attendu.",
    guideWeek34: "Semaine 3-4 : PREMIERS SIGNES",
    guideWeek34Text: "Possible légère réduction de l'intensité perçue. Moments où l'acouphène semble moins présent.",
    guideMonth23: "Mois 2-3 : PROGRESSION",
    guideMonth23Text: "Réduction progressive de l'intrusion. Périodes plus longues sans y penser.",
    guideMonth46: "Mois 4-6 : STABILISATION",
    guideMonth46Text: "Nouvelle 'normalité' établie. Acouphène moins gênant au quotidien.",
    
    guideCaution: "Attention",
    guideCautionText: "Les progrès sont progressifs et variables. Certains jours seront meilleurs que d'autres.",
    
    guidePositiveSigns: "Signes positifs",
    guideSign1: "J'oublie mon acouphène pendant plusieurs heures",
    guideSign2: "Il me gêne moins pendant mes activités",
    guideSign3: "Je dors mieux",
    
    guideConsultDoctor: "Consultez un médecin si",
    guideConsult1: "Acouphène apparu brutalement",
    guideConsult2: "Acouphène unilatéral (une seule oreille)",
    guideConsult3: "Perte auditive soudaine",
    
    // Tips
    guideTips: "Conseils et Meilleures Pratiques",
    guideDo: "À FAIRE",
    guideDo1: "Soyez régulier : tous les jours si possible",
    guideDo2: "Utilisez un bon casque audio (AirPods recommandés)",
    guideDo3: "Environnement calme pour maximiser l'effet",
    guideDo4: "Volume confortable, jamais trop fort",
    guideDo5: "Tenez un journal de vos progrès",
    
    guideDont: "À ÉVITER",
    guideDont1: "Attentes irréalistes : ce n'est pas instantané",
    guideDont2: "Volume trop élevé : risque de fatigue auditive",
    guideDont3: "Irrégularité : 1h/semaine < 15min/jour",
    guideDont4: "Arrêter trop tôt : donnez-vous 2-3 mois",
    
    // Audio Quality
    guideAudioQuality: "Qualité Audio Professionnelle",
    guideAudioQualityTitle: "🎵 Normalisation Audio Automatique",
    guideAudioQualityText: "Tous les sons sur HEAREN sont automatiquement normalisés selon les standards professionnels de l'industrie musicale pour garantir une expérience optimale et sécuritaire.",
    guideAudioStandards: "Standards Appliqués",
    guideAudioStandard1: "Loudness : -16 LUFS (norme Apple Music, Spotify, YouTube)",
    guideAudioStandard2: "Peak Limiting : -1.0 dBTP (True Peak) pour éviter toute saturation",
    guideAudioStandard3: "EBU R128 : Standard européen de broadcast professionnel",
    guideAudioBenefits: "Avantages pour Vous",
    guideAudioBenefit1: "Volume cohérent entre tous les sons - pas de surprises sonores",
    guideAudioBenefit2: "Zéro saturation même à volume élevé - protection auditive",
    guideAudioBenefit3: "Qualité audiophile optimisée pour casques et écouteurs premium",
    guideAudioBenefit4: "Conformité Apple Music pour une écoute sur tous vos appareils",
    guideAudioNote: "💡 Note",
    guideAudioNoteText: "Cette normalisation professionnelle s'applique automatiquement à tous les fichiers uploadés, qu'il s'agisse de sons de la bibliothèque ou de vos uploads personnalisés.",
    
    // Assistant
    assistant: "Assistant",
    assistantTitle: "Hearen Assistant",
    assistantSubtitle: "Un espace d’écoute et de présence",
    assistantPlaceholder: "Prenez un moment…",
    assistantWelcome:
      "Bienvenue dans l’espace Hearen. Prenez un moment pour respirer, ralentir et retrouver une écoute plus calme.",
    assistantDisclaimer:
      "💡 Hearen propose une expérience de bien-être et d’écoute immersive. Elle ne remplace pas un avis médical.",
    assistantSuggestion1: "Comprendre mes acouphènes",
    assistantSuggestion2: "Respiration & apaisement",
    assistantSuggestion3: "Choisir un son adapté",
    assistantSuggestion4: "Apaisement rapide - J'ai besoin d'aide",
    assistantTyping: "Hearen prépare votre espace…",
    assistantError: "Désolé, j'ai rencontré une erreur. Peux-tu réessayer ?",
    assistantNewChat: "Nouvel espace",
    assistantSend: "Envoyer",
    assistantPrivacyTitle: "Confidentialité :",
    assistantPrivacyLine1: "Vos échanges avec Hearen Assistant restent privés.",
    assistantPrivacyLine2: "Seuls vos derniers messages sont conservés pour garder la conversation cohérente.",
    assistantPrivacyLine3: "Rien n'est partagé avec des services externes et vous pouvez supprimer vos conversations à tout moment.",
    assistantDeleteConversation: "Supprimer cette conversation",
    assistantDeleteConfirmTitle: "Supprimer la conversation ?",
    assistantDeleteConfirmMessage: "Cette action est irréversible. Tous les messages de cette conversation seront définitivement supprimés.",
    assistantDeleteConfirmYes: "Oui, supprimer",
    assistantDeleteConfirmNo: "Annuler",
    assistantConversationDeleted: "Conversation supprimée",
    
    // Vision
    guideVision: "Notre Vision",
    guideVisionQuote: "Il ne s'agit pas d'éteindre le son. Il s'agit d'apprendre à le faire disparaître naturellement.",
    guideVisionText: "HEAREN s'adresse à celles et ceux qui refusent de subir leurs acouphènes comme une fatalité. Notre approche repose sur la science, la simplicité et le bien-être.",
    
    guideFooter: "Bienvenue dans votre voyage vers un mieux-être auditif.",
    
    // Creator Story
    creatorStoryTitle: "Pourquoi HEAREN existe",
    creatorStoryText: "HEAREN a été créé par un musicien, ancien acouphénique. Après 12 ans de recherche et sa propre guérison, il partage aujourd'hui sa méthode avec ceux qui souffrent.",
    
    // Radio Hearen
    radio: "Presence",
    radioHearen: "Presence",
    radioDesc: "Diffusion continue de paysages sonores avec messages apaisants",
    clickToPlay: "Cliquez pour démarrer",
    loading: "Chargement...",
    voiceVolume: "Volume voix",
    musicVolume: "Volume musique",
    next: "Suivant",
    selectRadioFirst: "Veuillez sélectionner une radio",
    noTrackPlaying: "Aucun morceau en cours de lecture",
    classicNotch: "Notch Classique",
    inverseNotch: "Inverse Notch",
    equalizer: "Égaliseur",
    tinnitus: "Acouphènes",
    settings: "Réglages",
    
    // Breathing screen i18n
    breathingTitle: "Respiration Apaisante",
    breathingTitleSimple: "Respiration Simple",
    breathingPattern: "4-2-6 • 1 minute",
    breathingPatternSilent: "4-2-6 • 1 minute • Silencieux",
    breathingPremiumNotice: "🔒 Fonctions Premium disponibles : exercices avancés, durées personnalisées, guidage Hera.",
    breathingReady: "Prêt à commencer ?",
    breathingInhale: "Inspirez profondément...",
    breathingHold: "Retenez votre souffle...",
    breathingExhale: "Expirez lentement...",
    breathingComplete: "Bravo ! Exercice terminé 🎉",
    breathingCycle: "Cycle",
    breathingPremiumTip: "Astuce : Le guidage vocal Hera est disponible dans Premium.",
    breathingDiscoverPremium: "Découvrir Premium",
    breathingStart: "Commencer",
    breathingStop: "Arrêter",
    breathingBack: "Retour",
    breathingRestart: "Recommencer",
    
    chooseVoice: "Choisir la voix :",
    voiceSettings: "Paramètres des messages vocaux",
    voiceMessages: "Messages vocaux",
    voice: "Voix",
    voiceHera: "Héra (Féminine)",
    voiceHeraDesc: "Voix apaisante féminine",
    messageInterval: "Intervalle entre messages",
    sleepMode: "Mode sommeil",
    sleepModeDesc: "3 messages au début, puis silence complet pour favoriser l'endormissement",
    noRadioSelected: "Aucune radio sélectionnée",
    playing: "En lecture...",
    paused: "En pause",
    radioInfoNote: "Presence diffuse en continu des paysages sonores de votre bibliothèque, entrecoupés de messages vocaux apaisants d'Héra.",
    
    // Tinnitus Test - Type Selection
    characterizeTinnitus: "Caractérisez votre acouphène",
    selectTinnitusType: "Sélectionnez le type de son qui correspond le mieux à votre acouphène",
    pleaseSelectTinnitusType: "Veuillez sélectionner un type d'acouphène avant de continuer",
    tinnitusTypeHighPitch: "Sifflement aigu",
    tinnitusTypeLowHum: "Bourdonnement grave",
    tinnitusTypeClicking: "Clic/Craquement",
    tinnitusTypePulsatile: "Pulsatile (battement)",
    tinnitusTypeModulated: "Sifflement modulé",
    tinnitusTypeWhiteNoise: "Bruit blanc/Statique",
    volumeLevel: "Niveau sonore",
    volumeInstruction: "Ajustez avec précision pour correspondre au volume de votre acouphène (paliers de 0.5 dB)",
    matchesMyTinnitus: "C'est le bon son",
    testComplete: "Test terminé",
    detectedFrequency: "Fréquence détectée",
    pause: "Pause",
    play: "Jouer",
    stop: "Arrêter",
    silence: "silence",
    
    
    // Lab Mode (Expérimental)
    labTitle: "Mode Lab (Expérimental)",
    labBeta: "Bêta",
    labViewPlan: "Voir le plan complet",
    labDisabledByAdmin: "Cette fonctionnalité est désactivée par l'administrateur.",
    labConsentTitle: "Programme expérimental « Lab »",
    labConsentLine1: "Méthodes audio personnalisées (notch / inverse notch) : efficacité variable selon les personnes.",
    labConsentLine2: "Possibles inconforts (fatigue auditive, hyperacousie). Vous pouvez arrêter à tout moment.",
    labConsentLine3: "Vos données (réglages, durée d'écoute) servent à personnaliser votre programme.",
    labConsentCheckbox: "J'ai compris et j'accepte d'accéder au Mode Lab.",
    labActionsCancel: "Annuler",
    labActionsEnableLab: "Activer le Mode Lab",
    labNotchTitle: "Classic Notch",
    labInverseTitle: "Inverse Notch",
    labInverseTooltip: "Boost modéré (+2…+4 dB) autour de votre fₜ. Fonction expérimentale, peut augmenter l'inconfort chez certains utilisateurs.",
    labFieldsFt: "Fréquence fₜ (Hz)",
    labFieldsBand: "Bande de fréquence",
    labFieldsGain: "Gain (dB)",
    labFieldsAutoFromTest: "Du test d'acouphène",
    labFieldsFixedBand: "Bande fixe",
    labSave: "Enregistrer",
    labToastSaved: "Réglages enregistrés",
    labToastError: "Erreur lors de l'enregistrement",
    planNotchSubtitle: "Cible 60–120 min/jour · 6–12 semaines",
    planInverseSubtitle: "Stimulation douce et progressive",
    planActivate: "Activer",
    planSettings: "Réglages",
    planSecSafety: "Panic-Stop disponible pendant les sessions · Peak limité à −1 dBFS",
    pitchTitle: "Pitch-matching guidé",
    pitchStep1: "Étape 1 — Balayage large bande",
    pitchStep2: "Étape 2 — Affinage ±100 Hz (3 essais)",
    pitchLikeMyTinnitus: "Ça ressemble à mon acouphène",
    pitchAvgFt: "Moyenne fₜ",
    pitchSaveAsFt: "Enregistrer comme fₜ",
    labActivateProgram: "Activer ce programme",
    labActivateLabFirst: "Activez d'abord le Mode Lab ci-dessus pour configurer ce programme",
    
    // Coach Hearen
    coachTitle: "Coach Hearen",
    coachSubtitle: "Votre plan personnalisé d'écoute",
    yourScore: "Votre Score",
    scoreExcellent: "Excellent",
    scoreGood: "Bien",
    scoreFair: "Correct",
    scoreNeedsWork: "À améliorer",
    
    // Score labels (10 niveaux)
    scoreExceptional: "🎉 Exceptionnel ! Vous êtes un champion !",
    scoreExcellentWork: "✨ Excellent travail ! Continuez ainsi !",
    scoreVeryGood: "💪 Très bien ! Vous progressez superbement !",
    scoreGoodRhythm: "👍 Bon rythme ! La régularité paie !",
    scoreOnTrack: "🌱 Vous êtes sur la bonne voie !",
    scoreEncouraging: "💫 Chaque pas compte ! Persévérez !",
    scoreMotivating: "🚀 Vous avez démarré ! La constance fera la différence !",
    scoreBeginning: "🌟 Beau début ! Continuez, les résultats arrivent !",
    scoreStart: "💚 Bravo d'avoir commencé ! Chaque séance vous rapproche du bien-être !",
    scoreFirstStep: "🌈 C'est le début de votre parcours ! Ensemble, étape par étape !",
    
    // Messages motivationnels
    // Coach motivational messages based on streak
    motivReadyToStart: "🎯 Prêt à commencer ? Votre séance du jour vous attend.",
    motivStreak1: "🎊 Beau début ! Continuez avec votre séance du jour.",
    motivStreak2_6: "⭐ Bonne constance ! Continuez comme ça.",
    motivStreak7Plus: "🔥 Excellente constance ! Vous maintenez un très bon rythme.",
    motivRestart: "🌱 Un nouveau départ — reprenons ensemble. Votre séance du jour est prête.",
    motivFirstSession: "🎊 Félicitations ! Vous avez franchi la première étape. L'élan est lancé !",
    motivGoalReached: "🏆 Objectif de la semaine atteint ! Vous êtes formidable !",
    motivAlmostThere: "💪 {done}/{target} séances ! Vous y êtes presque !",
    motivProgressing: "🌟 {done}/{target} séances ! Chaque effort compte et paie !",
    motivPerseverance: "💙 La persévérance transforme les défis en victoires. Vous êtes capable !",
    
    scoreExplanation: "Calculé sur adhérence (40%), temps (20%), régularité (20%), tendance (20%)",
    
    vasQuestion: "Comment vont vos acouphènes aujourd'hui ?",
    vasInstructions: "Évaluez l'intensité de vos acouphènes sur une échelle de 1 (très faible) à 10 (insupportable)",
    submitScore: "Enregistrer mon score",
    submitting: "Enregistrement...",
    submitted: "✓ Enregistré !",
    submittedRedirect: "✓ Enregistré ! Redirection...",
    redirectingToProgress: "📊 Ouverture de vos progrès...",
    errorSubmittingVAS: "Erreur lors de l'enregistrement du score",
    scoreSaved: "✓ Score enregistré",
    vasDeleteButton: "Effacer et recommencer",
    vasDeleteConfirmTitle: "Confirmer la suppression",
    vasDeleteConfirm: "Voulez-vous vraiment effacer votre score du jour ? Cela supprimera votre saisie et vous pourrez en enregistrer une nouvelle.",
    vasDeleteSuccess: "Score effacé avec succès. Vous pouvez maintenant en enregistrer un nouveau.",
    errorDeletingVAS: "Erreur lors de la suppression du score",
    vasScoreSavedMessage: "✅ Votre score a été enregistré avec succès !",
    viewProgress: "Voir mes progrès",
    vasScoreExists: "Un score existe déjà pour aujourd'hui. Veuillez l'effacer d'abord si vous voulez en soumettre un nouveau.",
    vasNoScoreToDelete: "Aucun score à supprimer pour aujourd'hui.",
    cancel: "Annuler",
    delete: "Supprimer",
    
    // Global Progress Score
    globalProgressScore: "Score de progression globale",
    globalProgressScoreSubtitle: "Votre progression globale basée sur les tendances à long terme.",
    globalProgressScoreTooltip: "Ce score représente votre progression globale sur plusieurs semaines ou mois. Il est basé sur les tendances observées dans : vos sessions, vos minutes d'écoute, vos variations de gêne perçue, votre constance dans le temps. Ce score reflète donc votre évolution à long terme.",
    
    // Weekly Coach Score
    weeklyCoachScore: "Score hebdomadaire Coach Hearen",
    weeklyCoachScoreSubtitle: "Votre activité et engagement cette semaine.",
    weeklyCoachScoreTooltip: "Ce score reflète uniquement votre activité de la semaine en cours. Il prend en compte : le nombre de sessions réalisées, les minutes d'écoute, l'atteinte de votre objectif hebdomadaire. Il mesure votre constance sur les derniers jours, pas votre progression globale.",
    
    weeklyProgress: "Progrès de la semaine",
    recalculate: "Recalculer",
    sessions: "Séances",
    sessionsCompleted: "Séances",
    minutesDone: "Minutes",
    streakDays: "Jours consécutifs",
    weekPlan: "Plan de la semaine",
    noSessionsPlanned: "Aucune séance planifiée",
    
    // Recommandations de tests
    audiometricTestRecommended: "⚠️ Test audiométrique recommandé",
    tinnitusTestRecommended: "⚠️ Test acouphènes recommandé",
    takeTest: "Effectuer le test",
    
    // Protocoles de séances
    completeTherapy: "Expérience sonore complète",
    completeTherapyInverse: "Correction pertes auditives + Notch inverse acouphènes",
    completeTherapyClassic: "Correction pertes auditives + Notch classique acouphènes",
    hearingLossCorrection: "Correction pertes auditives",
    inverseNotchTinnitus: "Notch inverse acouphènes",
    
    // Statuts de séances
    sessionCompleted: "✓ Effectuée",
    sessionToday: "📅 Aujourd'hui",
    sessionOverdue: "⚠️ En retard",
    sessionUpcoming: "⏳ À venir",
    startSessionBtn: "Démarrer",
    fadeOutInProgress: "Fade out en cours...",
    
    // Alerte séances en retard
    overdueSessionsAlert: "{count} séance(s) en retard",
    overdueMessage: "Rattrapez ces séances dès que possible pour maintenir votre progression.",
    overdueCanReschedule: "Vous pouvez les faire aujourd'hui ou dans les prochains jours.",
    overdueTip: "💡 Conseil : Chaque séance compte pour améliorer votre bien-être auditif",
    
    startSession: "Commencer une séance",
    coachSession: "Séance Coach Hearen",
    coachDisclaimer: "Outil de bien-être. Ne remplace pas un avis professionnel.",
    coachBetaTitle: "Coach Hearen (Bêta)",
    coachBetaMessage: "Cette fonctionnalité est en phase bêta. Contactez-nous pour y accéder.",
    errorLoading: "Erreur de chargement",
    errorRecalculating: "Erreur lors du recalcul du plan",
    retry: "Réessayer",
    coachMessage: "Message du Coach",
    startNow: "Commencer maintenant",
    viewPlan: "Voir mon plan",
    coachProgress: "Coach Hearen",
    trendUp: "En progression",
    trendDown: "À améliorer",
    trendStable: "Stable",
    weeklyGoal: "Objectif hebdo",
    minutes: "Minutes",
    streak: "Jours d'affilée",
    viewFullPlan: "Voir le plan complet",
    
    // Parler à Hearen (Chat Vocal) - TEMPORARY DISABLED
    talkToHearen: "Parler à Hearen",
    talkToHearenSubtitle: "Exprimez-vous librement, Hearen vous écoute et vous répond à la voix.",
    talkToHearenDescription: "Conversation vocale avec votre coach personnel",
    startTalking: "Commencer à parler",
    
    // Premium Page
    premiumTitle:
      "Aller un peu plus loin avec Hearen",
    premiumSubtitle:
      "Hearen Premium enrichit doucement votre expérience avec davantage de paysages sonores, une personnalisation plus profonde et un accompagnement plus attentif.",
    premiumFeature1Title:
      "Davantage de paysages sonores",

    premiumFeature1Desc:
      "Explorez plus d’environnements sonores et d’ambiances d’écoute.",
    premiumFeature2Title:
      "Présence guidée par Hera",
    premiumFeature2Desc:
      "Des expériences Presence plus riches et plus immersives.",

    premiumFeature3Title:
      "Playlists personnelles",
    premiumFeature3Desc:
      "Organisez vos moments d’écoute plus librement.",
    premiumFeature4Title:
      "Repères de progression",
    premiumFeature4Desc:
      "Suivez votre rythme d’écoute et votre évolution dans le temps.",
    premiumFeature5Title:
      "Une écoute plus personnelle",
    premiumFeature5Desc:
      "Des recommandations et ajustements plus contextualisés.",
    premiumFeature6Title:
      "Une expérience plus profonde",
    premiumFeature6Desc:
      "Laissez Hearen vous accompagner plus loin, à votre rythme.",
    premiumMonthly: "Mensuel",
    premiumYearly: "Annuel",
    perMonth: "/mois",
    perYear: "/an",
    save25: "Économisez 25%",
    choosePlan: "Choisissez Votre Plan",
    mostPopular: "Le Plus Populaire",
    upgradeNow:
      "Découvrir Hearen Premium",

    whatsIncluded: "Tout Ce Qui Est Inclus",
    benefit1: "Accès illimité à tous les sons",
    benefit2: "Toutes les expériences Presence",
    benefit3: "Playlists personnalisées illimitées",
    benefit4: "Coach Hearen avancé",
    benefit5: "Statistiques détaillées",
    benefit6: "Séances sans limite de durée",
    benefit7: "Nouvelles fonctionnalités en priorité",
    benefit8: "Support prioritaire",
    faqTitle: "Questions Fréquentes",
    faq1Q: "Puis-je annuler à tout moment ?",
    faq1A: "Oui, vous pouvez annuler votre abonnement à tout moment depuis les paramètres de votre compte.",
    faq2Q: "Y a-t-il une période d'essai ?",
    faq2A: "Oui, profitez de 7 jours d'essai gratuit pour découvrir toutes les fonctionnalités Premium.",
    faq3Q: "Que se passe-t-il si j'annule ?",
    faq3A: "Vous conservez l'accès Premium jusqu'à la fin de votre période de facturation, puis votre compte repasse en version gratuite.",
    readyToUpgrade:
      "Continuer avec Hearen ?",
    upgradeMessage:
      "Hearen Premium ouvre un espace d’écoute plus profond, plus personnel et plus immersif.",
    startNow: "Commencer Maintenant",
    
    // Premium Popup
    premiumPopupTitle:
      "Aller un peu plus loin avec Hearen",
    premiumPopupDescription:
      "Hearen Premium enrichit doucement votre expérience avec davantage de paysages sonores, une personnalisation plus profonde et un accompagnement plus discret.",
    featureBlocked:
      "Disponible avec Hearen Premium",
    quickBenefit1: "✨ Accès illimité à tous les sons",
    quickBenefit2: "🎵 Toutes les stations radio",
    quickBenefit3: "📊 Statistiques détaillées",
    upgradeToPremium:
      "Découvrir Hearen Premium",
    maybeLater:
      "Continuer pour l’instant",
    voiceChatIdle: "En attente",
    voiceChatListening: "Hearen vous écoute…",
    voiceChatThinking: "Réflexion…",
    voiceChatSpeaking: "Hearen parle…",
    voiceChatError: "Erreur",
    microphoneError: "Impossible d'accéder au microphone. Veuillez vérifier les permissions.",
    readyToListen: "Prêt à vous écouter",
    pressToSpeak: "Appuyez sur le microphone pour parler",
    exchanges: "échanges",
    stop: "Stop",
    reset: "Réinitialiser",
    
    // Methodology Page - French
    methodologyTitle: "Méthodologie Scientifique HEAREN",
    methodologySubtitle: "Fondements et limitations de notre approche",
    referenceStandards: "Standards de référence",
    iso389desc: "Acoustique - Zéro de référence pour l'étalonnage d'équipements audiométriques - Partie 8: Niveaux de référence équivalents de seuil pour les écouteurs purs à conduction aérienne dans le coupleur acoustique HA-1.",
    application: "Application",
    iso389app: "Conversion dB HL → dB SPL pour chaque fréquence de test.",
    iso8253desc: "Acoustique - Méthodes d'essais audiométriques - Partie 1: Audiométrie tonale liminaire par conduction aérienne et par conduction osseuse.",
    iso8253app: "Méthode par paliers ascendants pour la détection des seuils auditifs.",
    iso226desc: "Acoustique - Lignes isosoniques normales (courbes d'égale sonie).",
    iso226app: "Prise en compte de la perception fréquence-dépendante de l'oreille humaine.",
    hearenMethod: "Méthode HEAREN",
    calibrationPhase: "1. Phase de calibration",
    spatialTest: "Test de spatialisation",
    spatialTestDesc: "Vérification du fonctionnement correct du casque (gauche/droite).",
    multiFreqCalibration: "Calibration multi-fréquences",
    multiFreqCalibrationDesc: "Détermination des seuils de référence sur 3 fréquences (500 Hz, 1000 Hz, 4000 Hz) couvrant le spectre grave-aigu.",
    ascendingMethod: "Méthode par paliers ascendants",
    ascendingMethodDesc: "Ton pur commençant à 0 dB HL, augmentation de 5 dB toutes les 2 secondes jusqu'à perception. 3 confirmations par fréquence pour fiabilité.",
    calibrationOffset: "Calcul de l'offset de calibration",
    calibrationOffsetDesc: "Moyenne pondérée des écarts entre seuils mesurés et attendus, avec poids accru pour 1000 Hz (référence audiométrique standard).",
    testPhase: "2. Phase de test audiométrique",
    frequencies: "Fréquences testées",
    volumeCalculation: "Calcul du volume",
    volumeCalculationDesc: "Conversion dB HL → dB SPL via tables ISO 389-8, puis dB SPL → amplitude digitale, avec application de l'offset de calibration.",
    autoIncrement: "Incrémentation automatique",
    autoIncrementDesc: "Paliers de 5 dB HL toutes les 3 secondes, plage 0-120 dB HL.",
    testPerEar: "Test par oreille",
    testPerEarDesc: "Chaque fréquence testée sur oreille gauche puis droite.",
    reliabilityScore: "3. Score de fiabilité",
    symmetry: "Symétrie gauche-droite",
    symmetryDesc: "Pénalité si écarts supérieurs à 10 dB entre oreilles (pathologie ou erreur de mesure).",
    slope: "Pente audiométrique",
    slopeDesc: "Détection de sauts supérieurs à 30 dB entre fréquences adjacentes (incohérent physiologiquement).",
    extremeValues: "Valeurs extrêmes",
    extremeValuesDesc: "Alerte si seuils inférieurs à -10 dB HL (suspect) ou supérieurs à 90 dB HL (bruit ambiant ou problème matériel).",
    finalScore: "Score final",
    webAdaptations: "Adaptations pour environnement web",
    webAdaptationsDesc: "Contrairement à un audiomètre clinique étalonné, HEAREN fonctionne dans un environnement non-contrôlé. Voici nos adaptations :",
    relativeCalibration: "Calibration relative",
    relativeCalibrationDesc: "Au lieu d'une calibration absolue (impossible sans matériel certifié), nous utilisons une calibration relative basée sur les seuils de l'utilisateur.",
    multiFreqValidation: "Validation multi-fréquences",
    multiFreqValidationDesc: "3 points de calibration (vs 1 seul en général) pour détecter les incohérences matérielles.",
    reliabilityScoring: "Scoring de fiabilité",
    reliabilityScoringDesc: "Transparence sur la qualité des mesures, permettant à l'utilisateur d'identifier les tests à refaire.",
    safetyLimits: "Limites de sécurité",
    safetyLimitsDesc: "Volume maximal limité à 0.9 (90% amplitude) pour prévenir tout risque auditif, même en cas d'erreur.",
    appropriateUse: "Usage approprié de HEAREN",
    use1: "Évaluation préliminaire",
    use1Desc: "Obtenir une première indication de son profil auditif avant consultation ORL.",
    use2: "Personnalisation sonore",
    use2Desc: "Adapter les paramètres sonores selon le profil.",
    use3: "Suivi indicatif",
    use3Desc: "Comparer l'évolution dans le temps (avec les mêmes conditions: casque, environnement).",
    use4: "Sensibilisation",
    use4Desc: "Comprendre le fonctionnement d'un test audiométrique et l'importance de la santé auditive.",
    bibliography: "Bibliographie et références",
    questions: "Questions sur notre méthodologie ?",
    contactDesc: "Nous sommes transparents sur notre approche et ses limitations. Pour toute question technique ou scientifique, n'hésitez pas à nous contacter.",
  },

  // Clinical Audiogram Capture
  clinicalAudiogramFormatTitle: "Quel est le format de votre audiogramme ?",
  clinicalAudiogramFormatDesc:
    "Touchez le schéma qui correspond à votre document.",
  clinicalAudiogramSingleFrame: "1 cadre",
  clinicalAudiogramDualFrame: "2 cadres",

  // Clinical Audiogram
  clinicalAudiogramTitle: "Lire un audiogramme clinique",
  clinicalAudiogramIntro:
    "Si vous disposez d’un audiogramme réalisé par un ORL ou un audioprothésiste, Hearen peut essayer de le lire afin de construire une première synthèse de votre audition.",
  clinicalAudiogramFooter:
    "Hearen ne réalise pas un audiogramme. Il lit un document réalisé par un professionnel, puis vous demandera confirmation avant toute intégration à votre profil.",
  
  
  en: {
    // Navigation
    home: "Home",
    audiometricTest: "Explore my hearing",
    tinnitusTest: "Explore my tinnitus",
    therapy: "Soundscapes",
    playlists: "Playlists",
    playlistsDesc: "Create and listen to your personalized soundscapes",
    playlistsHomeDesc: "Your personalized sounds",
    myPlaylists: "My Playlists",
    playlistsSubtitle: "Your personalized sounds",
    history: "History",
    progress: "Progress Tracking",
    profile: "Profile",
    guide: "Guide",

    matrix: {
      profile_ready:
        'Your listening experience is ready.',

      hera_profile_ready:
        'Your listening experience is already personalized. Let Hearen do the rest.',
        
      adjust_listening:
        "Adjust my listening →",

      discovery: 'You can begin gently.',
      evening_return: 'Return softly to your evening atmosphere.',
      fatigue_softening: 'A quiet moment may help right now.',
      ready_for_deeper:
        'A few minutes can gently enrich your listening experience.',

      hera_breathe_and_listen:
        'Simply take a few moments to listen.',

      hera_evening_soft_listening:
       'Tonight, a soft listening session may be enough.',

      hera_no_need_to_force:
        "There is nothing you need to achieve right now. Just listen.",

      hera_familiar_sound:
        'A familiar soundscape can sometimes help more than a new one.',

      hera_personalization_can_wait:
        'You can personalize later. For now, a few minutes of listening may be enough.',
    },
    
    // Auth
    loginTitle: "Log in",
    loginDesc: "Log in to your Hearen account",
    email: "Email",
    password: "Password",
    login: "Log in",
    register: "Sign up",
    logout: "Log out",
    connectedAs: "Logged in as",
    loading: "Loading...",
    noAccount: "Don't have an account yet?",
    registerLink: "Sign up",
    forgotPassword: "Forgot password?",
    forgotPasswordPage: {
      title: "Forgot password",
      intro: "Enter your email address to receive a password reset link.",
      placeholder: "your@email.com",
      submit: "Send reset link",
      loading: "Sending…",
      back: "Back to login",
      success: "If an account matches this address, a password reset email has been sent.",
      requestError: "Unable to send the request right now. Please try again.",
      genericError: "An error occurred. Please try again."
    },
    resetPassword: {
      subtitle: "Password reset",
      title: "Choose a new password",
      hint: "Your new password must contain at least 8 characters.",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      submit: "Change my password",
      loading: "Updating…",
      successTitle: "Password changed",
      successMessage: "Your password has been changed.",
      successReturn: "You can now return to Hearen and log in with your new password.",
      invalidLink: "This password reset link is invalid.",
      expiredLink: "This password reset link is invalid or has expired.",
      mismatch: "The two passwords do not match.",
      tooShort: "Your password must contain at least 8 characters.",
      genericError: "An error occurred. Please try again.",
      changeError: "Unable to change the password."
    },
    
    // Home tiles
    soundscapes: "Soundscapes",
    yourSpace: "Your space",
    soundscapesHomeDesc: "Immersive sound. No voice.",
    presence: "Presence",
    presenceHomeDesc: "The voice of Hera.",
    nightMode: "Cocoon",
    nightModeHomeDesc: "A gentle space when silence feels too present",
    nightModeSubtitle: "A gentle space when silence feels too present",
    nightModeEnter: "Enter Cocoon",
    nightModePlaying: "Playing",
    nightModePaused: "Paused",
    nightModeTransition: "Changing...",
    nightModeNext: "Next",
    sosCalm: "SOS Calm",
    sosCalmHomeDesc: "Instant calm, in one tap",
    
    // Home Hero - V1.1.1
    homeHeroTitle: "Enter the calm",
    homeHeroSubtitle: "One tap. Infinite space.",
    
    // V1.1: Home redesign
    homeV11Title: "Your Space",
    homeV11Subtitle: "Choose your vibe.",
    comingSoon: "Coming soon",
    tabHome: "Home",
    tabFavorites: "Favorites",
    tabProfile: "Profile",
    favoritesTitle: "Favorites",
    favoritesLabel: "Favorites",
    playlistsLabel: "Playlists",
    noFavorites: "No favorites yet",
    noPlaylists: "No playlists",
    tracks: "tracks",
    addToPlaylist: "Add to playlist",
    soundAddedToPlaylist: "Added to playlist",
    playlistCreatedSuccess: "Playlist created",
    enterPlaylistName: "Playlist name",
    createNewPlaylist: "New playlist",
    deletePlaylistTitle: "Delete playlist?",
    playlistDeleted: "Playlist deleted",
    trackRemoved: "Track removed",
    session: "Session",
    voiceGuidance: "Voice guidance",
    voiceOnDesc: "Hera guides you",
    voiceOffDesc: "Immersive sound only",
    startSession: "Start session",
    themes: {
      nature: "Nature",
      relaxation: "Relaxation",
      sleep: "Sleep",
      meditation: "Meditation",
      pulseFlow: "Pulse Flow",
      instrumental: "Instrumental",
      lofi: "Lofi",
      deepCalm: "Deep Calm",
    },

    player: {
      audio_profile_active:
        'Listening profile active',

      presence_audio_profile_active:
        'Hera presence · Listening profile active',
    },
    
    // Progress page
    locale: "en-US",
    progressScore: "Progress Score",
    exportPDF: "Export PDF",
    exportPDFSoon: "PDF export coming soon",
    days: "days",
    trendImproving: "Great progress!",
    trendAttention: "Making progress - Keep going!",
    trendStable: "Positive evolution",
    kpiDays: "Days",
    kpiMin: "Min",
    kpiVAS: "VAS",
    kpiTinnitus: "Tinnitus",
    kpiHz: "Hz",
    kpiDaysTooltip: "Number of days you completed at least one listening session",
    kpiMinTooltip: "Average duration of your sound listening sessions per day",
    kpiVASTooltip: "Your latest tinnitus intensity assessment (scale 1-10)",
    kpiVASTooltipTitle: "📊 VAS - Visual Analog Scale",
    kpiVASTooltipDesc: "Measures your perceived tinnitus intensity from 1 (very mild) to 10 (unbearable).",
    kpiVASTooltipCurrent: "Current score:",
    kpiVASTooltipBaseline: "Initial score:",
    kpiVASTooltipNote: "💡 A lower score indicates improvement",
    kpiVASFrom: "from",
    kpiTinnitusTooltip: "Dominant frequency of your tinnitus detected in your last test",
    labDescription: "Access experimental Notch and Inverse Notch programs",
    
    dailyScoreTooltipTitle: "🧮 How is the Daily Score calculated?",
    dailyScoreCase1: "Case 1: VAS + Listening",
    dailyScoreCase1Desc: "Score = (VAS Score × 50%) + (Adherence Score × 50%)",
    dailyScoreCase1Example: "• VAS Score: (10 - your_VAS) × 10 (lower VAS = better)",
    dailyScoreCase1Example2: "• Adherence Score: (minutes / 15) × 100 (15min = 100%)",
    dailyScoreCase2: "Case 2: Listening only",
    dailyScoreCase2Desc: "Score = (minutes / 15) × 100",
    dailyScoreCase2Example: "• 15 minutes = 100 points • 30 minutes = 100 points (max)",
    dailyScoreCase3: "Case 3: VAS only",
    dailyScoreCase3Desc: "Score = (10 - your_VAS) × 10",
    dailyScoreNote: "💡 Note: High score = good day (low VAS + regular listening)",
    
    // Progress Page Update - Spec Nov 2025
    progressBannerTitle: "Your Progress Overview",
    progressBannerDesc: "Track your listening time, tinnitus perception and daily wellbeing evolution.",
    
    // KPI Cards - New Wording
    kpiDaysActive: "Days Active",
    kpiDaysActiveSubtext: "Since you started",
    kpiDaysActiveTooltip: "Total number of days since you started using Hearen.",
    
    kpiTherapyTime: "Listening Time",
    kpiTherapyTimeSubtext: "min today",
    kpiTherapyTimeTooltip: "Total listening time completed today (or this week).",
    
    kpiVASPerceived: "VAS (perceived intensity)",
    kpiVASPerceivedSubtext: "(perceived intensity)",
    kpiVASPrevious: "Previous:",
    kpiVASPerceivedTooltip: "Your VAS score: subjective discomfort scale from 0 (none) to 10 (very strong).",
    
    kpiTinnitusPitch: "Tinnitus Pitch",
    kpiTinnitusPitchSubtext: "Your current frequency",
    kpiTinnitusPitchTooltip: "The dominant pitch of your tinnitus, measured in Hertz (Hz).",
    
    // Graphs
    therapyMinutesPerDayDesc: "Total duration of sound listening sessions completed each day.",
    therapyMinutesRecommendation: "Recommended daily target: 15 minutes",
    
    tinnitusImpactScore: "Tinnitus Impact Score",
    tinnitusImpactScoreDesc: "Your daily impact score (0 = low, 100 = high), based on your own self-reported data.",
    tinnitusImpactScoreWarning: "This score reflects your daily tinnitus discomfort based on your own feedback. It is not linked to your listening minutes.",
    tinnitusImpactTooltip: "This graph shows only your self-reported tinnitus discomfort, day by day. It does not include listening minutes or any automatically generated calculation. Each point reflects exactly what you selected when you rated your tinnitus for that day. The optional trendline simply helps visualize your general progression.",
    
    // Variations info
    variationsInfoShort: "Daily variations are normal. Focus on your overall trend.",
    tooltipVariationsTitle: "Daily variations are normal",
    tooltipVariationsText: "Your tinnitus can vary from day to day — this is completely normal. These fluctuations often depend on stress, sleep, fatigue, focus or ambient noise. What matters most is your overall trend over several days, not a single day's value.",
    onboardingVariationsText: "Your tinnitus may fluctuate from day to day — this is completely normal. The dashboard focuses mainly on your long-term progress.",
    ok: "OK",
    showTrendline: "Show trendline",
    impactScore: "Impact",
    trendline: "Trend",
    
    progressBannerExplain: "Hearen tracks two different types of data: your listening activity (objective) and your tinnitus perception (subjective). These indicators are not computed from each other.",
    
    sectionTherapyActivity: "Your Listening Activity",
    sectionTherapyActivityDesc: "Objective data: your sound listening sessions and time spent",
    sectionTinnitusPerception: "Your Tinnitus Perception",
    sectionTinnitusPerceptionDesc: "Subjective data: how you experience your tinnitus",
    
    // Tinnitus Impact Score - Interpretive Summary v1.2
    summaryImproving: "Improving",
    summaryImprovingText: "Your average tinnitus impact is decreasing this week (-{percentage}%).",
    summaryStable: "Stable",
    summaryStableText: "Your tinnitus perception is relatively stable this week.",
    summaryIncreasing: "Increasing",
    summaryIncreasingText: "Your tinnitus impact is higher this week (+{percentage}%).",
    
    // Graph Legend
    legendDailyImpact: "Daily impact",
    legendTrendline: "Trendline",
    legendMovingAvg: "7-day average",
    legendPurpleLine: "Purple line:",
    legendPurpleDesc: "your self-reported daily tinnitus impact (0 = low, 100 = high)",
    legendBlueLine: "Blue dotted line:",
    legendBlueDesc: "overall trend (helps visualize general progression)",
    legendGreyLine: "Light grey line:",
    legendGreyDesc: "7-day moving average",
    therapyMinutesPerDay: "Listening Minutes per Day",
    dailyScore: "Daily Score",
    audiometricEvolution: "Audiometric Evolution",
    audiogramComparison: "Comparison between first test (dashed line) and latest (solid line)",
    insightsTitle: "Insights & Recommendations",
    loading: "Loading...",
    noData: "No data available. Complete tests and listening sessions to see your progress.",
    duration: "Duration",
    baselineLeft: "Baseline Left",
    baselineRight: "Baseline Right",
    currentLeft: "Current Left",
    currentRight: "Current Right",
    progressTitle: "Progress",
    yourProgress: "Your Progress",
    weeklyOverview: "Weekly Overview",
    monthlyTrend: "Monthly Trend",
    downloadReport: "Download Report",
    noDataAvailable: "No data available. Complete tests and listening sessions to see your progress.",
    insightsRecommendations: "Insights & Recommendations",
    makingProgress: "Making progress - Keep going!",
    positiveEvolution: "Positive evolution",
    pdfExportSoon: "PDF export coming soon",
    therapyMinutesPerDay: "Listening Minutes per Day",
    dailyScore: "Daily Score",
    comparisonFirstLatest: "Comparison between first test (dashed line) and latest (solid line)",
    
    // AudiometricTest.js
    audiometricTestTitle: "Audiometric Test",
    audiometricInstructions: "Wear headphones (AirPods recommended) and adjust volume comfortably",
    selectEar: "Select ear to test",
    nextFrequency: "Next frequency",
    yourResults: "Your results",
    threshold: "Threshold",
    volumeAdjustment: "Volume adjustment for this frequency",
    
    // TinnitusTest.js
    tinnitusTestTitle: "Tinnitus Identification Test",
    tinnitusInstructions: "Find the frequency that best matches your tinnitus",
    adjustFrequency: "Adjust frequency",
    adjustVolume: "Adjust volume",
    stopFrequency: "Stop",
    closeMatch: "Close",
    exactMatch: "Exact",
    finishTest: "Finish",
    tinnitusCharacteristics: "Tinnitus characteristics",
    detectedFrequency: "Detected frequency",
    perceivedVolume: "Perceived volume",
    tinnitusVolumeDesc: "Perceived volume in dB SPL - Goal: decrease over time",
    tinnitusFrequencyDesc: "Detected frequency in Hz over time",
    
    // V1.1: Free/Premium Limits
    favoritesLimitReached:
      "Hearen Premium allows you to save more favorites.",
    playlistLimitReached:
      "Hearen Premium allows multiple playlists.",
    limitReached:
      "Available with Hearen Premium",
    
    // Calibration.js
    calibrationSubtitle: "Essential step before tests",
    disclaimerTitle: "Important - Limitations and Appropriate Use",
    disclaimerWarning: "HEAREN is a complementary wellness tool, A WELLBEING TOOL.",
    whatHearenCanDo: "What HEAREN can do:",
    canDo1: "Indicative assessment of your hearing profile",
    canDo2: "Personalization of soundscapes",
    canDo3: "Progress tracking",
    methodology: "Methodology:",
    methodologyDesc: "Based on ISO 389-8 and ISO 8253-1 (with adaptations for non-clinical environment)",
    consultORL: "In case of tinnitus, ALWAYS consult an ENT doctor",
    understoodContinue: "Understood, continue",
    calibrationTitle: "Headphone Calibration (AirPods recommended)",
    calibrationDesc: "Professional configuration for reliable results",
    calibrationImportant: "Calibration ensures accurate and consistent results",
    calibrationPrerequisites: "Hardware requirements:",
    headphoneRecommended: "Recommended headphones (AirPods recommended):",
    headphoneDesc: "Circumaural (over-ear) or quality in-ear",
    quietEnvironment: "Environment:",
    quietEnvironmentDesc: "Quiet room, no background noise",
    systemVolume: "System volume:",
    systemVolumeDesc: "Set volume to 100% (test will adjust automatically)",
    calibrationSteps: "Calibration steps:",
    calibrationStep1: "Spatialization check (left/right)",
    calibrationStep2: "Multi-frequency calibration (500, 1000, 4000 Hz)",
    calibrationStep3: "Consistency validation",
    calibrationWarning: "Important: Do not change volume after calibration",
    startCalibration: "Start calibration",
    spatialTestTitle: "Step 1: Spatialization Check",
    spatialTestDesc: "Verify your headphones (AirPods recommended) work correctly",
    spatialInstructions: "Listen to sounds and confirm you hear in the correct ear:",
    testLeft: "Test left ear",
    testRight: "Test right ear",
    testBoth: "Test both",
    stop: "Stop",
    continueToMultiFreq: "Continue to multi-frequency calibration",
    multiFreqTitle: "Step 2: Multi-Frequency Calibration",
    multiFreqDesc: "Calibration of sound levels at different frequencies",
    currentFrequency: "Current frequency",
    currentLevel: "Current level",
    confirmation: "Confirmation",
    multiFreqInstructions: "Click 'I hear' as soon as you perceive the sound. Volume increases automatically every 2 seconds.",
    iHear: "I hear",
    stopSound: "Stop sound",
    completedFrequencies: "Completed frequencies:",
    calibrationComplete: "Calibration complete",
    calibrationGood: "✓ Good calibration quality",
    calibrationGoodDesc: "Results are consistent across frequencies.",
    calibrationWarningTitle: "⚠️ Moderate consistency",
    calibrationWarningDesc: "Thresholds vary between frequencies. Results are usable but environment may be noisy.",
    calibrationResults: "Calibration results:",
    calibrationOffset: "Calibration offset",
    startTest: "Start audiometric test",
    calibrationTooLoud: "Too high level reached. Check your headphones (AirPods recommended) and system volume.",
    autoDetectionUnavailable: "ℹ️ Automatic detection unavailable. Make sure to use quality headphones (AirPods recommended).",
    retry: "🔄 Retry",
    bluetoothHeadphoneDetected: "✓ Bluetooth Headphones (AirPods recommended) detected",
    step1Title: "Put on your headphones (AirPods recommended)",
    step1Desc: "Make sure they are properly positioned",
    step2Title: "Listen to reference sound",
    step2Desc: "Click 'Play' below",
    step3Title: "Adjust volume",
    step3Desc: "Sound should be audible but comfortable",
    tooQuiet: "Too quiet",
    perfect: "Perfect",
    tooLoud: "Too loud",
    goToTests: "Go to tests",
    whyCalibrate: "Why calibrate?",
    calibrationExplanation: "Calibration ensures all tests are performed with a precise and comfortable reference volume for your hearing.",
    
    // Tests.js & AudiometricTest.js
    testsSubtitle: "Assess your hearing and tinnitus",
    progressSubtitle: "Analyze your path to silence",
    backToSelection: "Back to selection",
    completeAudioTestDesc: "Complete audiometric test with professional calibration",
    testCharacteristics: "Test Characteristics",
    sevenFrequencies: "7 frequencies tested (125Hz - 8000Hz)",
    separateEarTest: "Test for each ear separately",
    testDuration: "Duration: ~10-15 minutes",
    complianceNote: "Compliance Note:",
    hearenNoMedicalData: "HEAREN does not collect wellbeing results. The integrated tests are designed for wellness self-assessment and do not replace clinical advice.",
    therapySubtitle: "Personalized soothing sounds",
    playlistsSubtitleHome: "Your favorite sessions",
    radioSubtitleHome: "Thematic channels",
    historySubtitle: "Your test results",
    sosSubtitleHome: "Immediate Calm",
    wellnessStatement: "HEAREN is a wellness app designed to help you restore balance and auditory comfort in your daily life.",
    calibrationStatus: "Status",
    calibrated: "Calibrated",
    notCalibrated: "Not calibrated",
    never: "Never",
    testsImportant: "Tests are essential",
    testsImportantDesc: "They allow precise personalization of your soundscapes for best results",
    
    // SOS.js
    sosSubtitle: "In case of intense tinnitus crisis",
    howAreYouFeeling: "How are you feeling?",
    veryCritical: "Critical",
    difficult: "Difficult",
    manageable: "Manageable",
    quickReliefTitle: "Immediate Calm",
    quickReliefDesc:
      "Soothing sounds for a softer listening environment",
    contactSupportDesc: "Professional help available 24/7",
    emergencyTitle: "Need Support?",
    emergencyDesc: "If you need support, please reach out to a healthcare professional",
    callEmergency: "Contact Support",
    sosHelp: "We are here for you",
    sosHelpDesc: "Take a few minutes to calm down. Everything will be fine.",
    
    // SOSCalm.js
    sosCalmSubtitle: "Cardiac coherence technique",
    breathingExercise: "Breathing Exercise",
    cycleCount: "Cycle",
    feelingBetter: "Feeling better?",
    backToSOS: "Back",
    exerciseBenefits: "Benefits",
    benefitCalm: "Reduces stress and anxiety",
    benefitHeartRate: "Regulates heart rate",
    benefitFocus:
      "Helps create a focused environment",
    
    // RadioHearen.js
    radioSubtitle: "Continuous soundscapes programs",
    upNext: "Up next",
    nowPlaying: "Now playing",
    endSession: "End session",
    // Radio channel labels (NO "Radio" suffix - context is clear from screen)
    channelFocus: "Focus",
    channelFocusDesc: "Concentration and productivity",
    channelRelax: "Relaxation",
    channelRelaxDesc: "Relaxation and calm",
    channelSleep: "Sleep",
    channelSleepDesc: "For restful sleep",
    channelNature: "Nature",
    channelNatureDesc: "Soothing natural sounds",
    channelChill: "Chill / Lofi",
    channelChillDesc: "Soft modern atmospheres",
    channelNoise: "Noise",
    channelNoiseDesc: "White noise and textures",
    channelPulseFlow: "Pulse Flow",
    channelPulseFlowDesc: "Modern, controlled and harmonious energy — by Hearen.",
    channelClassical: "Classical",
    channelClassicalDesc: "Soothing classical music",
    channelMeditation: "Meditation",
    channelMeditationDesc: "Meditative accompaniment",
    listeningTime: "Listening time",
    listeners: "listeners",
    
    // CustomSounds.js
    customSoundsSubtitle: "Import your own audio files",
    uploadInstructions: "Accepted formats: MP3, WAV, OGG, FLAC",
    maxFileSize: "Maximum size: 50 MB",
    selectFile: "Select a file",
    uploading: "Uploading...",
    uploadSuccess: "Sound uploaded successfully",
    uploadError: "Upload error",
    soundDeleted: "Sound deleted successfully",
    
    // Playlists.js
    playlistsSubtitle: "Create custom sequences",
    playlistName: "Playlist name",
    addSounds: "Add sounds",
    soundsInPlaylist: "Sounds in playlist",
    removeSoundFromPlaylist: "Remove from playlist",
    deletePlaylist: "Delete playlist",
    playlistSaved: "Playlist saved",
    playlistDeleted: "Playlist deleted",
    editPlaylist: "Edit playlist",
    playPlaylist: "Play playlist",
    shufflePlaylist: "Shuffle",
    loopPlaylist: "Loop",
    
    // GetStarted.js
    welcomeToHearen: "Welcome to Hearen",
    yourJourneyStarts: "Your journey to auditory wellness starts here",
    step1Action: "Calibrate now",
    step2Action: "Take tests",
    step3Action: "Start listening",
    whyTheseSteps: "Why these steps?",
    stepsExplanation: "These steps allow precise personalization of your soundscapes for best results.",
    skipForNow: "Skip for now",
    alreadyCompleted: "Already completed",
    
    // Onboarding
    lessThan3Months: "Less than 3 months",
    threeToSixMonths: "3 to 6 months",
    sixToTwelveMonths: "6 months to 1 year",
    moreThanOneYear: "More than one year",
    bothEars: "Both",
    fluctuating: "Fluctuating",
    highPitchRinging: "High-pitch ringing",
    highPitchDesc: "Continuous high-pitched sound (8000-12000 Hz)",
    lowHumming: "Low humming",
    lowHummingDesc: "Deep low sound (100-250 Hz)",
    clickingCracking: "Clicking/Cracking",
    clickingDesc: "Sharp repetitive sounds",
    pulsatileBeating: "Pulsatile (beating)",
    pulsatileDesc: "Rhythmic synchronized beating",
    modulatedWhistle: "Modulated whistle",
    modulatedDesc: "Sound that varies in intensity",
    whiteNoiseStatic: "White noise/Static",
    whiteNoiseDesc: "Continuous background noise like 'radio'",
    otherDesc: "Different type from above descriptions",
    question: "Question",
    howLongTinnitus: "How long have you been experiencing your tinnitus?",
    whichSideTinnitus: "On which side do you experience your tinnitus?",
    whatYouWillGet: "What you will get",
    benefit1: "Soothing sounds adapted to your needs",
    benefit2: "A personalized journey according to your profile",
    benefit3: "Targeted recommendations for your well-being",
    importantInformation: "Important information",
    consentText: "I understand that HEAREN is a wellness and sound education app, a wellbeing tool.",
    importantWarning: "Important warning",
    disclaimerText: "HEAREN is a wellness and sound education app. It does not replace professional advice. In case of new, intense experiences, or pulsatile tinnitus, consult a healthcare professional.",
    close: "Close",
    timeEstimate: "⏱️ Less than 2 minutes to personalize your experience",
    letsSetupProfile: "Let's set up your profile",
    skipOnboarding: "Skip introduction",
    nextStep: "Next step",
    previousStep: "Previous step",
    completeSetup: "Complete setup",
    setupComplete: "Setup complete!",
    startUsingHearen: "Start using Hearen",
    whatIsHearen: "What is Hearen?",
    hearenDescription:
      "Hearen is an immersive listening app designed to create calmer and more personalized sound experiences.",
    letsBegin: "Let's begin",
    constantly: "Constantly",
    rarely: "Rarely",
    verySevere: "Very severe",
    mild: "Mild",
    ringing: "Ringing",
    hissing: "Hissing",
    clicking: "Clicking",
    impactSleep: "Sleep",
    impactConcentration: "Concentration",
    impactMood: "Mood",
    impactSocial: "Social life",
    impactWork: "Work",
    notAtAll: "Not at all",
    aLittle: "A little",
    quite: "Quite",
    extremely: "Extremely",
    haveSeenSpecialist: "Have you seen a specialist?",
    specialistType: "Specialist type",
    ent: "ENT",
    audiologist: "Audiologist",
    psychologist: "Psychologist",
    currentMedications: "Current medications",
    previousTherapies: "Approaches tried",
    hearingAids: "Hearing aids",
    acupuncture: "Acupuncture",
    preferredLanguage: "Preferred language",
    notificationPreferences: "Notifications",
    enableNotifications: "Enable notifications",
    dailyReminders: "Daily reminders",
    progressUpdates: "Progress updates",
    therapyPreferences: "Listening preferences",
    preferredSoundCategory: "Preferred sound category",
    themePreference: "App theme",
    lightTheme: "Light",
    darkTheme: "Dark",
    autoTheme: "Auto",
    
    audioProfileDescription:
      "Your listening adapts in real time for greater comfort.",

    // Home page
    welcome: "Welcome to Hearen",
    welcomePersonalized: "Hello",
    welcomeBack: "Hello",
    welcomeSubtitle: "Personalized soundscapes for tinnitus",
    dashboardSubtitle: "Your personalized soundscapes space",
    homeSubtitle: "Your personalized dashboard",
    homeHeroTitle: "Enter the calm",
    homeHeroSubtitle: "One tap. Infinite space.",
    chooseExperience: "Choose your experience",
    discoverHearenBadge: "✨ Discover Hearen",
    useHeadphones: "Use headphones (AirPods recommended) for best results",
    getStarted: "Get Started",
    aboutTitle: "About Hearen",
    aboutDesc: "Hearen helps you manage your tinnitus through hearing tests and personalized soundscapes.",
    yourResults: "Your results",
    notCompleted: "Not completed",
    view: "View",
    start: "Start",
    nextStep: "Next step",
    completeAudiometric: "Complete the audiometric test to personalize your experience.",
    completeTinnitus: "Complete the tinnitus test for personalized soundscapes.",
    testsComplete: "Tests completed",
    readyForTherapy: "You can now enjoy personalized soundscapes adapted to your profile.",
    startTherapy: "Start soundscapes",
    
    // New Home Components
    coachTitle: "Your Personal Coach",
    coachDescription: "Follow your personalized plan and assess your daily progress",
    viewPlan: "View my plan",
    startConversation: "Start conversation",
    
    // Daily Check-in (Redirect to Coach)
    evaluateTinnitusToday: "Evaluate your tinnitus today",
    openCoachToRate: "Open the Coach to rate today's intensity",
    moodGood: "Good",
    moodOkay: "Okay",
    moodBad: "Difficult",
    
    // Therapy Tiles
    therapyAccess: "Soundscapes Access",
    radio: "Presence",
    radioDesc: "Guided programs",
    therapyDesc: "Personalized sessions",
    sos: "Quick Calm",
    sosDesc: "Quick calm",
    
    // Progress Summary
    yourProgress: "Your Progress",
    seeAll: "See all",
    totalTime: "Total time",
    sessions: "Sessions",
    streak: "Active streak",
    progressNote: "Check your Progress page for full details",
    weekSummary: "sessions this week",
    minShort: "min",
    
    // Tools Tiles
    toolsAndTests: "Tools & Tests",
    explore: "Explore",
    yourSpace: "Your Space",
    
    // Profile Page
    labTitle: "Lab Mode (Experimental)",
    labBeta: "Beta",
    labDescription: "Experimental Notch/Inverse Programs",
    adminTitle: "Administration",
    adminDescription: "Library & Voice Messages",
    resetOnboarding: "Reset Onboarding (Test)",
    viewOnboarding: "View Onboarding",
    confirmReset: "Confirm Reset",
    confirmResetMessage: "Do you really want to reset your onboarding profile? You will be able to redo the complete questionnaire.",
    yesReset: "Yes, reset",
    cancel: "Cancel",
    resetting: "Resetting...",
    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    updatePassword: "Update",
    passwordUpdated: "Password updated successfully",
    passwordError: "Error updating password",
    passwordMismatch: "Passwords do not match",
    
    // History Page
    therapySessions: "Listening Sessions",
    therapyHistory: "History of your sessions",
    therapyHistoryDesc: "History of your sound listening sessions",
    totalSessions: "Total Sessions",
    favoriteTherapy: "Favorite Soundscape",
    incomplete: "Incomplete",
    therapyAdjustment: "Sound Adjustment",
    learnMore: "Learn more",
    therapyMethodExplained: "🎯 Sound Method",
    therapyPhilosophy: "It's not about turning off the sound. It's about learning to make it naturally disappear.",
    audiometricTests: "Audiometric Tests",
    testsDesc: "Assess your hearing",
    testsHomeDesc: "Evaluate your hearing",
    assistantDesc: "Ask your questions",
    assistantHomeDesc: "Ask your questions",
    guideDesc: "Understand the method",
    guideHomeDesc: "Understand the approach",
    settingsDesc: "Customization",
    settingsHomeDesc: "Personalization",
    sosCalm: "SOS Calm",
    sosCalmDesc: "Immediate calm",
    settings: "Settings",
    
    // Tests page
    tests: "Tests",
    testsSubtitle: "Assess your hearing and tinnitus",
    calibrationDesc: "Equipment check and spatialization adjustment",
    calibration: "Calibration",
    calibrationBundle: "Calibration & hearing test",
    calibrationBundleDesc: "Adjust your listening, then measure your hearing",
    audiometricTestDesc: "Let Hearen gradually adapt to your perception.",
    tinnitusTestDesc: "Identify the tone closest to your tinnitus perception to personalize your sound environment.",
    testsInfo: "These steps help Hearen personalize your sound environment.",
    
    // Hearing Knowledge
    hearingKnowledgeTitle: "Know Your Hearing",
    hearingKnowledgeIntro:
      "Your hearing is unique. Hearen can begin to understand it in two ways.",

    exploreMyHearing: "Explore My Hearing",
    exploreMyHearingDesc:
      "Choose how Hearen can begin to understand your hearing.",

    startHearingTest: "Take a Hearen Hearing Test",
    startHearingTestDesc:
      "Explore your hearing directly in the app.",

    readClinicalAudiogram: "Read a Clinical Audiogram",
    readClinicalAudiogramDesc:
      "Use an audiogram performed by a hearing professional.",

    viewHistoryDesc:
      "Find your previous results and follow your progress over time.",

    hearingKnowledgeFooter:
      "Both approaches then allow Hearen to personalize your listening experience.",

    // Guide
    guide: "Guide",
    
    // Audiometric Test
    audiometricTitle: "Audiometric Test",
    audiometricDesc: "Assess your hearing at different frequencies (or import your professional test)",
    selectEar: "Select ear",
    leftEar: "Left ear",
    rightEar: "Right ear",
    bothEars: "Both",
    incomplete: "Incomplete",
    startTest: "Start test",
    iHear: "I hear it",
    nextFrequency: "Next frequency",
    testComplete: "Test complete!",
    saveResults: "Save results",
    testing: "Testing...",
    testInProgress: "Audiometric test in progress",
    currentVolume: "Current volume",
    stopTest: "Stop test",
    
    // Calibration
    calibrationTitle: "Headphone Calibration (AirPods recommended)",
    calibrationDesc: "Before starting the audiometric test, we need to calibrate your headphones (AirPods recommended)",
    calibrationImportant: "Calibration ensures accurate and consistent results",
    calibrationSteps: "Calibration steps:",
    calibrationStep1: "Verify spatialization (left/right)",
    calibrationStep2: "Adjust system volume to a comfortable level",
    calibrationStep3: "Validate that the reference sound (25 dB HL) is clearly audible",
    calibrationWarning: "Important: Do not change your computer volume after calibration",
    startCalibration: "Start calibration",
    spatialTestTitle: "Step 1: Spatialization Check",
    spatialTestDesc: "Verify your headphones (AirPods recommended) are correctly positioned",
    spatialInstructions: "Listen to the following sounds and confirm you hear them in the correct ear:",
    testLeft: "Test left ear",
    testRight: "Test right ear",
    testBoth: "Test both",
    continueToVolumeCalibration: "Continue to volume calibration",
    volumeCalibrationTitle: "Step 2: Volume Calibration",
    volumeCalibrationDesc: "Adjust volume until you clearly hear the reference sound",
    referenceSound: "Reference sound: 25 dB HL",
    referenceSoundDesc: "This sound represents a whisper or very quiet conversation. It should be clearly audible but not loud.",
    playReferenceSound: "Play reference sound",
    adjustSystemVolume: "Adjust listening volume to the minimum threshold at which you perceive the sound:",
    calibrationSliderDesc: "Use this slider for fine adjustment:",
    calibrationReady: "Once the sound is clearly audible and comfortable, validate calibration",
    validateCalibration: "Validate and start test",
    back: "Back",
    stop: "Stop",
    
    // Tinnitus Test
    tinnitusTitle: "Tinnitus Test",
    tinnitusDesc: "Identify your tinnitus frequency",
    step1: "Step 1: Broad search",
    step2: "Step 2: Fine-tuning",
    matchesMyTinnitus: "That's it!",
    adjustFrequency: "Adjust frequency",
    currentFrequency: "Current frequency",
    detectedFrequency: "Detected frequency",
    adjustVolumeForTherapy: "This volume must precisely cover your tinnitus, it will be used for your personalized soundscapes",
    volumeLevel: "Sound level",
    volumeInstruction: "Adjust precisely to match your tinnitus volume (0.5 dB increments)",
    
    // Therapy
    therapyTitle: "Soundscapes",
    therapeuticSound: "Soothing Sound",
    therapyDesc: "Listen to personalized soothing sounds",
    soundCategory: "Sound category",
    sound: "Sound",
    selectCategory: "Sound category",
    selectSound: "Choose a sound",
    playlistSounds: "Playlist sounds",
    chooseSound: "Select a sound...",
    selectTherapyType: "Sound type",
    inverseNotch: "Inverse Notch",
    pinkNoise: "Pink Noise",
    brownNoise: "Brown Noise",
    whiteNoise: "White Noise",
    natureSounds: "Nature Sounds",
    musicalStyles: "Musical Styles",
    play: "Play",
    pause: "Pause",
    stop: "Stop",
    volume: "Volume",
    duration: "Duration",
    minutes: "minutes",
    sessionTime: "Session time",
    personalizedEqualizer: "Personalized Equalizer",
    audiometricCompensation: "Audiometric Compensation",
    audiometricCompensationDesc: "Adjusts volume based on your hearing profile",
    audiometricCompensationDescInactive: "Perform an audiometric test to activate",
    tinnitusTherapy: "Focused Listening (Inverse Notch)",
    tinnitusTherapyDescActive: "Adaptive boost",
    tinnitusTherapyDescInactive: "Perform a tinnitus test to activate",
    soundWillRestart: "Sound will be automatically restarted with new settings",
    performTestsToActivate: "Perform audiometric and tinnitus tests to activate these features",
    audioProcessing: "Audio Processing",
    equalizerLabel: "Audiometric Equalizer",
    notchLabel: "Tinnitus",
    tinnitusLabel: "Tinnitus",
    frequenciesCompensated: "frequencies compensated",
    selectSoundAlert: "Please select a sound",
    errorPlayingSound: "Error playing sound",
    errorSavingSession: "Error saving session",
    errorToggleFavorite: "Error adding to favorites",
    
    // ===== CANONICAL THEMES (SINGLE SOURCE OF TRUTH) =====
    // Used by Radio, Soundscapes, Playlists - DO NOT ADD "Radio" TO LABELS
    themes: {
      nature: "Nature",
      relaxation: "Relaxation",
      sleep: "Sleep",
      meditation: "Meditation",
      pulseFlow: "Pulse Flow",
      classical: "Classical",
      chillLofi: "Chill / Lofi",
    },
    
    // Therapy categories (legacy - prefer themes.* for new code)
    categoryNature: "Nature",
    categoryRelaxation: "Relaxation",
    categorySleep: "Sleep",
    categoryFocus: "Focus",
    categoryNoise: "Noise",
    categoryTones: "Pure Tones",
    categoryMySounds: "My Sounds",
    categoryFavorites: "Favorites",
    noSoundsInCategory: "No sounds available in this category",
    addToFavorites: "Add to favorites",
    removeFromFavorites: "Remove from favorites",
    
    // Legacy categories (keep for compatibility)
    categoryClassique: "Classical Music",
    categoryJazz: "Jazz",
    categoryAmbiance: "Ambiance",
    categoryChill: "Chill",
    categoryElectro: "Electro",
    noCustomSounds: "No custom sounds. Upload your sounds in 'Custom Sounds'.",
    
    // Nature sounds
    birds: "Birds",
    ocean: "Ocean",
    stream: "Stream",
    storm: "Storm",
    
    // Generated sounds
    whiteNoiseName: "White Noise",
    pinkNoiseName: "Pink Noise",
    brownNoiseName: "Brown Noise",
    pureTone440: "Pure Tone 440 Hz",
    pureTone1000: "Pure Tone 1000 Hz",
    
    // History
    historyTitle: "History",
    historyDesc: "View your results and progress",

    historyAccessTitle: "My history",
    historyAccessDesc: "View your results, charts and progress over time.",
    viewHistory: "View history",

    historyTabAudiogram: "Audiograms",
    historyTabTinnitus: "Tinnitus",
    historyTabTherapy: "Sessions",
    
    audiogramHistory: "Audiogram History",
    audiogramDesc: "Visualization of your hearing thresholds by frequency",
    tinnitusHistoryDesc: "Detected tinnitus frequencies",
    tinnitusHistory: "Tinnitus History",
    frequencyEvolution: "Frequency Evolution",
    frequencyEvolutionDesc: "Chart showing the evolution of your tinnitus over time",
    noData: "No data available",
    date: "Date",
    ear: "Ear",
    frequency: "Frequency",
    threshold: "Threshold",
    type: "Type",
    totalSessions: "Total sessions",
    totalTime: "Total time",
    testHistory: "Test history",
    frequencies: "frequencies",
    active: "Active",
    personalized: "personalized",
    personalizedListening: "personalized listening (tinnitus)",
    audioProfileLabel: "Audio profile",
    enabled: "Active",
    confidence: "Confidence",
    therapeuticGain: "Sound enhancement",
    measuredVolume: "Measured volume",
    appliedBoost: "Applied boost",
    appliedAttenuation: "Applied attenuation",
    therapyPrincipleNotch:
      "This Notch approach targets your listening frequency to create a more balanced sound environment and support a calmer listening experience over time.",
    therapyPrincipleInverseNotch:
      "The applied boost targets your listening frequency to encourage gradual adaptation and a more natural listening experience. This approach remains intentionally gentle and aims to support habituation over time.",
    therapyPrinciple:
      "The approach favors gradual and comfortable listening to gently support your sound experience.",
    lowFrequency: "Low",
    midFrequency: "Mid",
    highFrequency: "High",
    veryHighFrequency: "Very high",
    favoriteTherapy: "Favorite soundscapes",
    deleteTestConfirmTinnitus: "Are you sure you want to delete this tinnitus test?",
    deleteTestConfirmAudiometric: "Are you sure you want to delete this audiometric test?",
    errorDeletingTest: "Error deleting test",
    tinnitusFrequencyEvolution: "Tinnitus Frequency Evolution",
    tinnitusVolumeEvolution: "Tinnitus Volume Evolution",
    frequencyHz: "Frequency (Hz)",
    volumeDbSPL: "Volume (dB SPL)",
    frequencyDetectedOverTime: "Frequency detected in Hz over time",
    volumePerceivedOverTime: "Volume perceived in dB SPL - Goal: decrease over time",
    severityLow: "Low",
    severityMedium: "Medium",
    severityHigh: "High",
    
    // Professional Audiogram Import
    importProfessionalTest: "Import a Clinical Audiogram",
    importProfessionalDesc: "Capture your clinical audiogram. Hearen will analyze it automatically.",
    clickToUpload: "Capture an audiogram",
    analyzeWithAI: "Analyze the audiogram",
    analyzing: "Analyzing...",
    analysisComplete: "Analysis complete",
    saveTest: "Save audiogram",
    saving: "Saving...",
    cancel: "Cancel",
    
    customSounds: "Custom Sounds",
    customSoundsDesc: "Upload your own soothing sounds",
    customSoundsTitle: "Personal Sound Library",
    mySounds: "My Sounds",
    mySoundsDesc: "Manage your custom sound library",
    soundName: "Sound name",
    enterSoundName: "Enter a name...",
    selectFile: "Select file",
    dragDropOrClick: "Drag & drop or click to select",
    upload: "Upload",
    uploading: "Uploading...",
    uploadError: "Upload error. Please try again.",
    nameRequired: "Please provide a name for your sound.",
    noSounds: "No custom sounds. Upload your first sound!",
    confirmDelete: "Are you sure you want to delete this sound?",
    confirmDeleteTitle: "Confirm deletion",
    confirmDeleteMessage: "Are you sure you want to permanently delete",
    deleteError: "Deletion error.",
    delete: "Delete",
    
    // Playlists
    playlistsTitle: "My Playlists",
    playlistsDesc: "Create and manage your personalized playlists",
    newPlaylist: "New Playlist",
    noPlaylistsMessage: "No playlists. Create your first playlist!",
    createPlaylist: "Create Playlist",
    soundCount: "sound(s)",
    addSound: "Add",
    listen: "Listen",
    
    // Spectrum Analyzer
    spectrumAnalyzerTitle: "Professional Spectrum Analyzer",
    spectrumWillActivate: "The spectrum analyzer will activate during playback",
    levelDbSpl: "Level (dB SPL)",
    frequencyHz: "Frequency (Hz)",
    normalSignal: "Normal Signal",
    audiometricCompensation: "Audiometric Compensation",
    tinnitusFrequency: "Tinnitus Frequency",
    
    // Timer
    sessionTimer: "Session Timer",
    unlimited: "Unlimited",
    playbackContinueIndefinitely: "Playback will continue indefinitely",
    remaining: "remaining",
    playbackWillStop: "Playback will gradually stop after",
    timerMinutes: "minutes",
    timerOff: "Off",
    startTimer: "Start",
    stopTimer: "Stop",
    
    // Audio categories
    classique: "Classical",
    classiqueDesc: "Elegant and soothing soundscapes",
    pianoAmbiant: "Ambient",
    pianoAmbiantDesc: "Immersive and minimalist atmospheres",
    chillLofi: "Chill / Lofi",
    chillLofiDesc: "Warm modern textures for gentle focus",
    respiration: "Breathing & Meditation",
    respirationDesc: "Breathe, release",
    nature: "Nature",
    natureDesc: "Organic calming environments",
    bruitsTextures: "Noise & textures",
    bruitsTexturesDesc: "White / Pink / Brown",
    sommeil: "Sleep",
    sommeilDesc: "Deep relaxation",
    pulseFlow: "Pulse Flow",
    pulseFlowDesc: "Modern rhythmic energy for uplifted momentum",
    focus: "Focus",
    focusDesc: "Stress-free concentration",
    customSounds: "My sounds",
    customSoundsDesc: "Personal imports",
    favorites: "Favorites",
    favoritesDesc: "Your selection",
    sounds: "sounds",
    bruitsTexturesDesc: "White / Pink / Brown",
    sommeil: "Sleep",
    sommeilDesc: "Deep relaxation",
    focus: "Focus",
    focusDesc: "Stress-free concentration",
    customSounds: "My sounds",
    customSoundsDesc: "Personal imports",
    favorites: "Favorites",
    favoritesDesc: "Your selection",
    
    // Common
    left: "Left",
    right: "Right",
    both: "Both",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    hz: "Hz",
    db: "dB",
    
    // Instructions
    useHeadphones: "⚠️ Use headphones (AirPods recommended) for best results",
    adjustVolume: "Adjust volume to a comfortable level",
    listenCarefully: "Listen carefully and click \"I hear it\" as soon as you perceive the sound",
    frequencyWillBeUsed: "This frequency will be used to personalize your soundscapes",
    moveSliderBroad: "Move the slider to find approximately your tinnitus frequency",
    moveSliderFine: "Fine-tune to find the exact frequency",
    adjustUntilMatch: "Adjust the frequency until it matches your tinnitus",
    continueToTherapy: "Continue to soundscapes",
    initialFrequency: "Initial frequency",
    personalizedTherapy: "Personalized soundscapes for",
    noTinnitusDetected: "No tinnitus frequency detected. Please perform the tinnitus test first.",
    tip: "💡",
    testInstructions: "Test instructions:",
    setDeviceVolume100: "Set your device volume to 100% for this test",
    setDeviceVolume100Calibrated: "Set your device volume to maximum, the test level will be automatically calibrated",
    autoTestBothEars: "The test is performed automatically on both ears",
    eachFreqBothEars: "For each frequency: left ear then right ear",
    volumeIncreasesAuto: "Volume increases automatically by 5 dB HL every 3 seconds",
    clickWhenHear: "Click \"I hear it\" as soon as you perceive the sound",
    volumeIncreasesEvery2s: "Volume increases automatically by 5 dB HL every 3 seconds. Click as soon as you hear the sound.",
    highVolumeWarning: "High volume reached",
    autoSkipMessage: "If you still don't hear anything, the test will automatically move to the next frequency at 120 dB HL.",
    testVolume: "Test volume",
    adjustTestVolume: "Adjust test volume to your comfort (recommended: 90%)",
    testSpatialAudio: "Spatial audio test",
    testSpatialDesc: "Check that your headphones (AirPods recommended) work correctly by testing each ear:",
    
    // Guide - User Manual
    guideTitle: "User Guide",
    guideSubtitle: "Your auditory rehabilitation companion",
    guideImportant: "Important",
    guideImportantText: "HEAREN is a complementary, wellness-focused wellness method. It does not replace professional care. Always consult an ENT doctor if you have tinnitus.",
    guideTableOfContents: "Table of Contents",
    
    // Philosophy
    guidePhilosophy: "The HEAREN Philosophy",
    guidePhilosophyQuote: "The brain can relearn to hear differently",
    guidePhilosophyText:
      "Hearen is based on the idea that listening habits and sound environments can gradually evolve over time through gentle and regular listening experiences.",
    guidePhilosophy5Pillars: "The 5 Pillars of Our Method",
    
    guidePillar1Title: "Targeted and controlled stimulation",
    guidePillar1Text: "You identify your tinnitus frequency through a precise test. A slight sound amplification (inverted notch) is applied to promote cortical auditory activity reorganization.",
    guideNotchExplained: "Inverted notch explained",
    guideNotchExplainedText:
      "Instead of strongly altering your listening frequency, Hearen uses subtle sound adjustments designed to encourage a smoother and more natural listening experience.",
    
    guidePillar2Title:
      "Gradual listening adaptation",
    guidePillar2Text: "By stimulating the hyperactive area stably and repeatedly, the auditory system relearns to normalize its activity. The goal: progressively reduce the intensity and intrusion of the perceived sound.",
    
    guidePillar3Title: "Personalized music, integrated listening",
    guidePillar3Text: "Sound stimulation is delivered through real music that you choose. HEAREN subtly reinforces the targeted frequency within the music itself.",
    
    guidePillar4Title: "Soothing and autonomous experience",
    guidePillar4Text: "You always remain in control: choice of tracks, intensity, duration. Listening becomes a soothing daily practice.",
    
    guidePillar5Title: "Progressive and non-invasive method",
    guidePillar5Text: "No medication, no intrusive devices. Just targeted, gentle, and progressive sound stimulation that accompanies the ear and brain.",
    
    // How it works
    guideHowWorks: "How Does It Work?",
    guideScienceSimple: "Science in simple terms",
    guideScienceText:
      "Listening habits and sound perception can gradually evolve over time through gentle and regular listening experiences.",
    guideScienceText2: "HEAREN uses this plasticity to help your brain 'relearn' to process these signals correctly, gradually reducing the perception of tinnitus.",
    
    guide3Phases: "The 3 Phases of Rehabilitation",
    guidePhase1: "ASSESSMENT",
    guidePhase1Sub: "Your unique auditory profile",
    guidePhase2: "CALIBRATION",
    guidePhase2Sub: "Sound personalization",
    guidePhase3: "RE-EDUCATION",
    guidePhase3Sub: "Regular and progressive listening",
    
    // Steps
    guideStep1Title: "Step 1: Audiometric Test",
    guideStep1Goal: "Goal",
    guideStep1GoalText: "Assess your hearing across 7 key frequencies (125 Hz to 8000 Hz)",
    guideHowItWorks: "How it works",
    guideStep1Point1: "Headphone calibration",
    guideStep1Point1Text: "Adjust the reference volume (25 dB HL)",
    guideStep1Point2: "Automatic test",
    guideStep1Point2Text: "Volume increases progressively by 5 dB every 3 seconds",
    guideStep1Point3: "Your role",
    guideStep1Point3Text: "Click 'I hear it' as soon as you perceive the sound",
    guideStep1Point4: "Result",
    guideStep1Point4Text: "A personalized audiogram for both ears",
    
    guideAdvice: "Tip",
    guideStep1Tip1: "Use quality headphones (AirPods recommended)",
    guideStep1Tip2: "Find a quiet place",
    guideStep1Tip3: "System volume set to maximum initially",
    guideStep1Tip4: "Take your time, stay focused",
    
    guideWhatItProvides: "What it provides",
    guideStep1Provides1: "Identifies your hearing profile",
    guideStep1Provides2: "Allows soundscapes adjustment for optimal comfort",
    guideStep1Provides3: "Activates Audiometric Compensation in your listening experience",
    
    guideStep2Title: "Step 2: Tinnitus Test",
    guideStep2Goal: "Goal",
    guideStep2GoalText: "Precisely identify your tinnitus frequency",
    guidePhase1Title: "Phase 1 - Broad Search (500-8000 Hz)",
    guideStep2Phase1Point1: "Move the frequency slider",
    guideStep2Phase1Point2: "Click 'Play' to listen",
    guideStep2Phase1Point3: "Adjust until you find a similar sound",
    guideStep2Phase1Point4: "Click 'That's it!' to validate",
    guidePhase2Title: "Phase 2 - Fine-tuning (±100 Hz)",
    guideStep2Phase2Point1: "Refine the frequency in 10 Hz steps",
    guideStep2Phase2Point2: "Find the exact match",
    guideStep2Phase2Point3: "Validate",
    
    guideVolumeAdjustment: "Volume adjustment",
    guideStep2Volume1: "Use the 'Sound level' slider (10-60 dB SPL)",
    guideStep2Volume2: "Important: This volume must precisely cover your tinnitus",
    guideStep2Volume3: "It will be used to calculate your listening experience intensity",
    
    guideAdaptiveGain: "Adaptive Attenuation Calculated",
    guideBoost: "boost",
    guideAttenuation: "attenuation",
    therapyPoint2Updated: "Automatic calculation of soundscapes attenuation (proportional to volume)",
    therapyPoint3Updated: "Application of Classic Notch during your sound listening sessions",
    
    guideStep3Title: "Step 3: Personalized Soundscapes",
    guideStep3Goal: "Goal",
    guideStep3GoalText: "Progressively re-educate your auditory system",
    therapyMethodTitle: "🎯 Sound Method",
    howItWorks: "How it works:",
    therapyPoint1: "Measure your tinnitus (volume in dB SPL)",
    therapyPoint2: "Automatic calculation of sound enhancement (volume ÷ 5)",
    therapyPoint3: "Apply boost during your sound listening sessions",
    noiseRecommendation: "We recommend using white, brown, and pink noises in moderation, preferring natural sounds or musical styles.",
    guideTherapyChoice: "Choose sound type",
    guideSpectrumAnalyzer: "Spectrum Analyzer",
    guideSpectrumGreen: "Green: Normal frequencies",
    guideSpectrumOrange: "Orange: Audiometric compensation active",
    guideSpectrumRed: "Red: Notch/Inverse Notch filter on your tinnitus frequency",
    
    // Daily usage
    guideDailyUsage: "Daily Usage",
    guideBeginner: "Beginner",
    guideBeginnerSessions: "1-2 sessions",
    guideRegular: "Regular",
    guideRegularSessions: "2-3 sessions",
    guideIntensive: "Intensive",
    guideIntensiveSessions: "Multiple sessions",
    
    guideKey: "Key",
    guideRegularityKey: "Regularity is more important than duration. 20 min every day is better than 2h once a week.",
    
    guideBestTime: "Best time",
    guideMorning: "Morning: Start the day peacefully",
    guideLunch: "Lunch break: Relaxation moment",
    guideEvening: "End of day: Decompression after work",
    guideBedtime: "Before sleep: Facilitates falling asleep",
    
    guideGoldenRule: "Golden Rule",
    guideGoldenRuleText: "The sound must be comfortable, never uncomfortable.",
    
    // What to expect
    guideWhatToExpect: "What to Expect",
    guideWeek12: "Week 1-2: ADAPTATION",
    guideWeek12Text: "You familiarize yourself with the app. No notable change expected.",
    guideWeek34: "Week 3-4: FIRST SIGNS",
    guideWeek34Text: "Possible slight reduction in perceived intensity. Moments when tinnitus seems less present.",
    guideMonth23: "Month 2-3: PROGRESSION",
    guideMonth23Text: "Progressive reduction of intrusion. Longer periods without thinking about it.",
    guideMonth46: "Month 4-6: STABILIZATION",
    guideMonth46Text: "New 'normality' established. Tinnitus less bothersome in daily life.",
    
    guideCaution: "Caution",
    guideCautionText: "Progress is progressive and variable. Some days will be better than others.",
    
    guidePositiveSigns: "Positive signs",
    guideSign1: "I forget my tinnitus for several hours",
    guideSign2: "It bothers me less during activities",
    guideSign3: "I sleep better",
    
    guideConsultDoctor: "Consult a doctor if",
    guideConsult1: "Sudden onset tinnitus",
    guideConsult2: "Unilateral tinnitus (one ear only)",
    guideConsult3: "Sudden hearing changes",
    
    // Tips
    guideTips: "Tips and Best Practices",
    guideDo: "DO",
    guideDo1: "Be regular: every day if possible",
    guideDo2: "Use good headphones (AirPods recommended)",
    guideDo3: "Quiet environment to maximize effect",
    guideDo4: "Comfortable volume, never too loud",
    guideDo5: "Keep a journal of your progress",
    
    guideDont: "DON'T",
    guideDont1: "Unrealistic expectations: it's not instant",
    guideDont2: "Volume too high: risk of auditory fatigue",
    guideDont3: "Irregularity: 1h/week < 15min/day",
    guideDont4: "Stop too early: give yourself 2-3 months",
    
    // Audio Quality
    guideAudioQuality: "Professional Audio Quality",
    guideAudioQualityTitle: "🎵 Automatic Audio Normalization",
    guideAudioQualityText: "All sounds on HEAREN are automatically normalized according to professional music industry standards to guarantee an optimal and safe experience.",
    guideAudioStandards: "Applied Standards",
    guideAudioStandard1: "Loudness: -16 LUFS (Apple Music, Spotify, YouTube standard)",
    guideAudioStandard2: "Peak Limiting: -1.0 dBTP (True Peak) to prevent any saturation",
    guideAudioStandard3: "EBU R128: European professional broadcast standard",
    guideAudioBenefits: "Benefits for You",
    guideAudioBenefit1: "Consistent volume across all sounds - no sound surprises",
    guideAudioBenefit2: "Zero saturation even at high volume - hearing protection",
    guideAudioBenefit3: "Audiophile quality optimized for premium headphones and earbuds",
    guideAudioBenefit4: "Apple Music compliance for listening on all your devices",
    guideAudioNote: "💡 Note",
    guideAudioNoteText: "This professional normalization automatically applies to all uploaded files, whether from the library or your personal uploads.",
    
    // Assistant
    assistant: "Assistant",
    assistantTitle: "Hearen Assistant",
    assistantSubtitle:
      "A calm and immersive listening space",
    assistantPlaceholder:
      "Take a quiet moment…",
    assistantWelcome:
      "Welcome to the Hearen space. Take a moment to breathe, slow down and reconnect with a calmer listening experience.",
    assistantDisclaimer:
      "💡 Hearen provides an immersive listening and wellness experience. It does not replace medical advice.",
    assistantSuggestion1: "Understanding my tinnitus",
    assistantSuggestion2: "Breathing & calming",
    assistantSuggestion3: "Choose a suitable sound",
    assistantSuggestion4: "Quick Calm - I need help now",
    assistantTyping:
      "Hearen is preparing your space…",
    assistantError: "Sorry, I encountered an error. Can you try again?",
    assistantNewChat:
      "New space",
    assistantSend: "Send",
    assistantPrivacyTitle: "Privacy:",
    assistantPrivacyLine1: "Your conversations with Hearen Assistant stay private.",
    assistantPrivacyLine2: "Only your recent messages are kept to maintain a coherent dialogue.",
    assistantPrivacyLine3: "Nothing is shared with external services and you can delete your conversations at any time.",
    assistantDeleteConversation: "Delete this conversation",
    assistantDeleteConfirmTitle: "Delete conversation?",
    assistantDeleteConfirmMessage: "This action is irreversible. All messages in this conversation will be permanently deleted.",
    assistantDeleteConfirmYes: "Yes, delete",
    assistantDeleteConfirmNo: "Cancel",
    assistantConversationDeleted: "Conversation deleted",
    
    // Breathing screen i18n
    breathingTitle: "Calming Breathing",
    breathingTitleSimple: "Simple Breathing",
    breathingPattern: "4-2-6 • 1 minute",
    breathingPatternSilent: "4-2-6 • 1 minute • Silent",
    breathingPremiumNotice: "🔒 Premium features available: advanced exercises, custom durations, Hera guidance.",
    breathingReady: "Ready to begin?",
    breathingInhale: "Breathe in deeply...",
    breathingHold: "Hold your breath...",
    breathingExhale: "Exhale slowly...",
    breathingComplete: "Well done! Exercise complete 🎉",
    breathingCycle: "Cycle",
    breathingPremiumTip: "Tip: Hera voice guidance is available in Premium.",
    breathingDiscoverPremium: "Discover Premium",
    breathingStart: "Start",
    breathingStop: "Stop",
    breathingBack: "Back",
    breathingRestart: "Restart",
    
    // Vision
    guideVision: "Our Vision",
    guideVisionQuote: "It's not about turning off the sound. It's about learning to make it disappear naturally.",
    guideVisionText: "HEAREN is for those who refuse to accept their tinnitus as inevitable. Our approach is based on science, simplicity, and well-being.",
    
    guideFooter: "Welcome to your journey toward auditory wellness.",
    
    // Creator Story
    creatorStoryTitle: "Why HEAREN Exists",
    creatorStoryText: "HEAREN was created by a musician, a former tinnitus sufferer. After 12 years of research and his own recovery, he now shares his method with those who suffer.",
    
    // Radio Hearen
    radio: "Presence",
    radioHearen: "Presence",
    radioDesc: "Continuous broadcast of soothing sounds with soothing messages",
    clickToPlay: "Click to start",
    loading: "Loading...",
    voiceVolume: "Voice volume",
    musicVolume: "Music volume",
    next: "Next",
    selectRadioFirst: "Please select a radio first",
    noTrackPlaying: "No track currently playing",
    classicNotch: "Classic Notch",
    inverseNotch: "Inverse Notch",
    equalizer: "Equalizer",
    tinnitus: "Tinnitus",
    settings: "Settings",
    chooseVoice: "Choose voice:",
    voiceSettings: "Voice message settings",
    voiceMessages: "Voice messages",
    voice: "Voice",
    voiceHera: "Hera (Feminine)",
    voiceHeraDesc: "Soothing feminine voice",
    messageInterval: "Interval between messages",
    sleepMode: "Sleep mode",
    sleepModeDesc: "3 messages at the beginning, then complete silence to promote falling asleep",
    noRadioSelected: "No radio selected",
    playing: "Playing...",
    paused: "Paused",
    radioInfoNote: "Presence continuously broadcasts soothing sounds from your library, interspersed with soothing voice messages from Hera.",
    
    // Tinnitus Test - Type Selection
    characterizeTinnitus: "Characterize Your Tinnitus",
    selectTinnitusType: "Select the sound type that best matches your tinnitus",
    pleaseSelectTinnitusType: "Please select a tinnitus type before continuing",
    tinnitusTypeHighPitch: "High-pitched whistle",
    tinnitusTypeLowHum: "Low hum",
    tinnitusTypeClicking: "Clicking/Cracking",
    tinnitusTypePulsatile: "Pulsatile (beating)",
    tinnitusTypeModulated: "Modulated whistle",
    tinnitusTypeWhiteNoise: "White noise/Static",
    volumeLevel: "Sound level",
    volumeInstruction: "Adjust precisely to match your tinnitus volume (0.5 dB steps)",
    matchesMyTinnitus: "This matches my tinnitus",
    testComplete: "Test Complete",
    detectedFrequency: "Detected frequency",
    pause: "Pause",
    play: "Play",
    stop: "Stop",
    silence: "silence",
    
    // Lab Mode (Experimental)
    labTitle: "Lab Mode (Experimental)",
    labBeta: "Beta",
    labViewPlan: "View full plan",
    labDisabledByAdmin: "This feature is disabled by the administrator.",
    labConsentTitle: "Experimental Program 'Lab'",
    labConsentLine1: "Personalized audio methods (notch / inverse notch): effectiveness varies by person.",
    labConsentLine2: "Possible discomfort (listening fatigue, hyperacusis). You can stop at any time.",
    labConsentLine3: "Your data (settings, listening time) are used to personalize your program.",
    labConsentCheckbox: "I understand and agree to access Lab Mode.",
    labActionsCancel: "Cancel",
    labActionsEnableLab: "Enable Lab Mode",
    labNotchTitle: "Classic Notch",
    labInverseTitle: "Inverse Notch",
    labInverseTooltip: "Moderate boost (+2…+4 dB) around your fₜ. Experimental feature; may increase discomfort for some users.",
    labFieldsFt: "Frequency fₜ (Hz)",
    labFieldsBand: "Frequency band",
    labFieldsGain: "Gain (dB)",
    labFieldsAutoFromTest: "From tinnitus test",
    labFieldsFixedBand: "Fixed band",
    labSave: "Save",
    labToastSaved: "Settings saved",
    labToastError: "Error while saving",
    planNotchSubtitle: "Target 60–120 min/day · 6–12 weeks",
    planInverseSubtitle: "Gentle and progressive stimulation",
    planActivate: "Activate",
    planSettings: "Settings",
    planSecSafety: "Panic-Stop available during sessions · Peak limited to −1 dBFS",
    pitchTitle: "Guided Pitch Matching",
    pitchStep1: "Step 1 — Broadband sweep",
    pitchStep2: "Step 2 — ±100 Hz fine-tuning (3 trials)",
    pitchLikeMyTinnitus: "This matches my tinnitus",
    pitchAvgFt: "Average fₜ",
    pitchSaveAsFt: "Save as fₜ",
    labActivateProgram: "Activate this program",
    labActivateLabFirst: "First activate Lab Mode above to configure this program",
    
    // Coach Hearen
    coachTitle: "Coach Hearen",
    coachSubtitle: "Your personalized soundscapes plan",
    yourScore: "Your Score",
    scoreExcellent: "Excellent",
    scoreGood: "Good",
    scoreFair: "Fair",
    scoreNeedsWork: "Needs work",
    
    // Score labels (10 levels)
    scoreExceptional: "🎉 Exceptional! You're a champion!",
    scoreExcellentWork: "✨ Excellent work! Keep it up!",
    scoreVeryGood: "💪 Very good! You're progressing superbly!",
    scoreGoodRhythm: "👍 Good rhythm! Consistency pays off!",
    scoreOnTrack: "🌱 You're on the right track!",
    scoreEncouraging: "💫 Every step counts! Persevere!",
    scoreMotivating: "🚀 You've started! Consistency will make the difference!",
    scoreBeginning: "🌟 Great start! Keep going, results are coming!",
    scoreStart: "💚 Congrats on starting! Each session brings you closer to wellness!",
    scoreFirstStep: "🌈 It's the beginning of your journey! Together, step by step!",
    
    // Motivational messages
    // Coach motivational messages based on streak
    motivReadyToStart: "🎯 Ready to start? Your session for today is waiting.",
    motivStreak1: "🎊 Great start! Continue with today's session.",
    motivStreak2_6: "⭐ Nice consistency! Keep going.",
    motivStreak7Plus: "🔥 Excellent consistency! You're maintaining a great rhythm.",
    motivRestart: "🌱 A fresh start — let's begin again together. Your session for today is ready.",
    motivFirstSession: "🎊 Congratulations! You've taken the first step. Momentum is building!",
    motivGoalReached: "🏆 Weekly goal achieved! You're amazing!",
    motivAlmostThere: "💪 {done}/{target} sessions! You're almost there!",
    motivProgressing: "🌟 {done}/{target} sessions! Every effort counts and pays off!",
    motivPerseverance: "💙 Perseverance transforms challenges into victories. You're capable!",
    
    scoreExplanation: "Based on adherence (40%), time (20%), regularity (20%), trend (20%)",
    
    vasQuestion: "How is your tinnitus experience today?",
    vasInstructions: "Rate the intensity of your tinnitus on a scale from 1 (very mild) to 10 (unbearable)",
    submitScore: "Submit my score",
    submitting: "Submitting...",
    submitted: "✓ Submitted!",
    submittedRedirect: "✓ Submitted! Redirecting...",
    redirectingToProgress: "📊 Opening your progress...",
    errorSubmittingVAS: "Error submitting score",
    scoreSaved: "✓ Score saved",
    vasDeleteButton: "Delete and retry",
    vasDeleteConfirmTitle: "Confirm deletion",
    vasDeleteConfirm: "Are you sure you want to delete today's score? You will be able to enter a new one.",
    vasDeleteSuccess: "Score deleted successfully. You can now enter a new one.",
    errorDeletingVAS: "Error deleting score",
    vasScoreSavedMessage: "✅ Your score has been saved successfully!",
    viewProgress: "View my progress",
    cancel: "Cancel",
    delete: "Delete",
    vasScoreExists: "A score already exists for today. Please delete it first if you want to submit a new one.",
    vasNoScoreToDelete: "No score to delete for today.",
    
    // Global Progress Score
    globalProgressScore: "Global Progress Score",
    globalProgressScoreSubtitle: "Your overall improvement based on long-term trends.",
    globalProgressScoreTooltip: "This score represents your long-term improvement over several weeks or months. It is based on trends in: your sessions, your listening minutes, your self-reported discomfort evolution, your consistency over time. It reflects your long-term progress.",
    
    // Weekly Coach Score
    weeklyCoachScore: "Weekly Coach Score",
    weeklyCoachScoreSubtitle: "Your activity and engagement this week.",
    weeklyCoachScoreTooltip: "This score reflects only your activity for the current week. It considers: number of completed sessions, listening minutes, progress toward your weekly goal. It measures your short-term engagement, not your long-term improvement.",
    
    weeklyProgress: "Weekly Progress",
    recalculate: "Recalculate",
    sessions: "Sessions",
    sessionsCompleted: "Sessions",
    minutesDone: "Minutes",
    streakDays: "Streak Days",
    weekPlan: "Week Plan",
    noSessionsPlanned: "No sessions planned",
    
    // Test recommendations
    audiometricTestRecommended: "⚠️ Audiometric test recommended",
    tinnitusTestRecommended: "⚠️ Tinnitus test recommended",
    takeTest: "Take the test",
    
    // Session protocols
    completeTherapy: "Complete Sound Experience",
    completeTherapyInverse: "Hearing loss correction + Tinnitus inverse notch",
    completeTherapyClassic: "Hearing loss correction + Tinnitus classic notch",
    hearingLossCorrection: "Hearing loss correction",
    inverseNotchTinnitus: "Inverse notch tinnitus",
    
    // Session statuses
    sessionCompleted: "✓ Completed",
    sessionToday: "📅 Today",
    sessionOverdue: "⚠️ Overdue",
    sessionUpcoming: "⏳ Upcoming",
    startSessionBtn: "Start",
    fadeOutInProgress: "Fade out in progress...",
    
    // Overdue alert
    overdueSessionsAlert: "{count} session(s) overdue",
    overdueMessage: "Catch up on these sessions as soon as possible to maintain your progress.",
    overdueCanReschedule: "You can do them today or in the coming days.",
    overdueTip: "💡 Tip: Each session counts to improve your auditory wellness",
    
    startSession: "Start a session",
    coachSession: "Coach Hearen Session",
    coachDisclaimer: "Wellness tool. Does not replace professional advice.",
    coachBetaTitle: "Coach Hearen (Beta)",
    coachBetaMessage: "This feature is in beta phase. Contact us for access.",
    errorLoading: "Loading error",
    errorRecalculating: "Error recalculating plan",
    retry: "Retry",
    coachMessage: "Coach Message",
    startNow: "Start now",
    viewPlan: "View plan",
    coachProgress: "Coach Hearen",
    trendUp: "Improving",
    trendDown: "Needs work",
    trendStable: "Stable",
    weeklyGoal: "Weekly goal",
    minutes: "Minutes",
    streak: "Days in a row",
    viewFullPlan: "View full plan",
    
    // Help & Support Section
    helpSupportTitle: "Help & Support",
    helpSupportSubtitle: "Assistance, frequently asked questions and useful information",
    faqTitle: "Frequently Asked Questions",
    faq1Question: "Why does my score vary?",
    faq1Answer: "Daily variations are normal. Focus on the overall trend rather than day-to-day variations.",
    faq2Question: "I don't understand Notch / Inverse Notch.",
    faq2Answer: "These are targeted filters around your tinnitus frequency. You can freely enable/disable them in Lab Mode.",
    faq3Question: "I can't hear anything / sound too low.",
    faq3Answer: "Check your phone and headphone volume. Make sure the app volume is sufficient.",
    faq4Question: "When should I see an ENT specialist?",
    faq4Answer: "In case of sudden onset of tinnitus, severe pain, or significant anxiety, consult a healthcare professional.",
    contactSupportTitle: "Contact Support",
    contactSupportButton: "Contact support",
    wellbeingTitle: "Safety & Wellbeing",
    wellbeingMessage: "In case of severe distress or sudden onset of tinnitus, contact a healthcare professional or your country's support services.",
    
    // Help Icons Text
    therapyMinutesHelpText: "Total listening time each day. Recommended target: 15 minutes, no obligation.",
    audiometricHelpText: "Compares your first test (dashed lines) and your latest test (solid lines). Allows you to track overall hearing evolution.",
    tinnitusVolumeHelpText: "Your estimated volume in dB SPL. Day-to-day variations are normal.",
    tinnitusFrequencyHelpText: "Your estimated frequency in Hz. Slight variations are normal.",
    therapeuticSoundHelpText:
      "Notch and Inverse Notch apply a filter around your listening frequency to create a more personalized sound experience.",
    
    // Talk to Hearen (Voice Chat) - TEMPORARY DISABLED
    talkToHearen: "Talk to Hearen",
    talkToHearenSubtitle: "Speak freely, Hearen listens and responds by voice.",
    talkToHearenDescription: "Voice conversation with your personal coach",
    startTalking: "Start talking",
    
    // Premium Page
    premiumTitle:
      "Go a little further with Hearen",

    premiumSubtitle:
      "Hearen Premium gently enriches your listening experience with more soundscapes, deeper personalization and more attentive guidance.",   
    premiumFeature1Title:
      "More soundscapes",
    premiumFeature1Desc:
      "Explore additional listening environments and atmospheres.",
    premiumFeature2Title:
      "Presence guided by Hera",
    premiumFeature2Desc:
      "Richer and more immersive Presence experiences.",
    premiumFeature3Title:
      "Personal playlists",
    premiumFeature3Desc:
      "Organize your listening moments more freely.",
    premiumFeature4Title:
      "Progress insights",
    premiumFeature4Desc:
      "Follow your listening rhythm and evolution over time.",
    premiumFeature5Title:
      "A more personal experience",
    premiumFeature5Desc:
      "More contextual recommendations and adjustments.",
    premiumFeature6Title:
      "A deeper listening experience",
    premiumFeature6Desc:
      "Let Hearen accompany you further, at your own pace.",
    premiumMonthly: "Monthly",
    premiumYearly: "Yearly",
    perMonth: "/month",
    perYear: "/year",
    save25: "Save 25%",
    choosePlan: "Choose Your Plan",
    mostPopular: "Most Popular",
    upgradeNow:
      "Discover Hearen Premium",
    whatsIncluded: "What's Included",
    benefit1: "Unlimited access to all sounds",
    benefit2: "All Presence experiences",
    benefit3: "Unlimited personalized playlists",
    benefit4: "Advanced Coach Hearen",
    benefit5: "Detailed statistics",
    benefit6: "Sessions without time limits",
    benefit7: "Early access to new features",
    benefit8: "Priority support",
    faqTitle: "Frequently Asked Questions",
    faq1Q: "Can I cancel anytime?",
    faq1A: "Yes, you can cancel your subscription anytime from your account settings.",
    faq2Q: "Is there a trial period?",
    faq2A: "Yes, enjoy 7 days of free trial to discover all Premium features.",
    faq3Q: "What happens if I cancel?",
    faq3A: "You keep Premium access until the end of your billing period, then your account reverts to free version.",
    readyToUpgrade:
      "Continue with Hearen?",
    upgradeMessage:
      "Hearen Premium opens a deeper, more personal and immersive listening space.",
    startNow: "Start Now",
    
    // Premium Popup
    premiumPopupTitle:
      "Go a little further with Hearen",
    premiumPopupDescription:
      "Hearen Premium gently enriches your listening experience with more soundscapes, deeper personalization and quieter guidance.",
    featureBlocked:
      "Available with Hearen Premium",
    quickBenefit1: "✨ Unlimited access to all sounds",
    quickBenefit2: "🎵 All radio stations",
    quickBenefit3: "📊 Detailed statistics",
    upgradeToPremium:
      "Discover Hearen Premium",
    maybeLater:
      "Continue for now",
    voiceChatIdle: "Waiting",
    voiceChatListening: "Hearen is listening…",
    voiceChatThinking: "Thinking…",
    voiceChatSpeaking: "Hearen is speaking…",
    voiceChatError: "Error",
    microphoneError: "Cannot access microphone. Please check permissions.",
    voiceChatError: "An error occurred. Please try again.",
    readyToListen: "Ready to listen",
    pressToSpeak: "Press the microphone to speak",
    exchanges: "exchanges",
    stop: "Stop",
    reset: "Reset",
    retry: "Retry",
    
    // Methodology Page - English
    methodologyTitle: "HEAREN Scientific Methodology",
    methodologySubtitle: "Foundations and limitations of our approach",
    referenceStandards: "Reference Standards",
    iso389desc: "Acoustics - Reference zero for the calibration of audiometric equipment - Part 8: Reference equivalent threshold sound pressure levels for pure tones and circumaural earphones.",
    application: "Application",
    iso389app: "Conversion dB HL → dB SPL for each test frequency.",
    iso8253desc: "Acoustics - Audiometric test methods - Part 1: Pure-tone air and bone conduction audiometry.",
    iso8253app: "Ascending step method for threshold detection.",
    iso226desc: "Acoustics - Normal equal-loudness-level contours.",
    iso226app: "Accounting for frequency-dependent perception of the human ear.",
    hearenMethod: "HEAREN Method",
    calibrationPhase: "1. Calibration Phase",
    spatialTest: "Spatial Test",
    spatialTestDesc: "Verification of correct headphone function (left/right).",
    multiFreqCalibration: "Multi-frequency Calibration",
    multiFreqCalibrationDesc: "Determination of reference thresholds at 3 frequencies (500 Hz, 1000 Hz, 4000 Hz) covering the low-high spectrum.",
    ascendingMethod: "Ascending Step Method",
    ascendingMethodDesc: "Pure tone starting at 0 dB HL, increasing by 5 dB every 2 seconds until perception. 3 confirmations per frequency for reliability.",
    calibrationOffset: "Calibration Offset Calculation",
    calibrationOffsetDesc: "Weighted average of differences between measured and expected thresholds, with increased weight for 1000 Hz (standard audiometric reference).",
    testPhase: "2. Audiometric Test Phase",
    frequencies: "Tested Frequencies",
    volumeCalculation: "Volume Calculation",
    volumeCalculationDesc: "Conversion dB HL → dB SPL via ISO 389-8 tables, then dB SPL → digital amplitude, with calibration offset applied.",
    autoIncrement: "Automatic Increment",
    autoIncrementDesc: "5 dB HL steps every 3 seconds, range 0-120 dB HL.",
    testPerEar: "Test Per Ear",
    testPerEarDesc: "Each frequency tested on left ear then right ear.",
    reliabilityScore: "3. Reliability Score",
    symmetry: "Left-Right Symmetry",
    symmetryDesc: "Penalty if differences greater than 10 dB between ears (pathology or measurement error).",
    slope: "Audiometric Slope",
    slopeDesc: "Detection of jumps greater than 30 dB between adjacent frequencies (physiologically inconsistent).",
    extremeValues: "Extreme Values",
    extremeValuesDesc: "Alert if thresholds below -10 dB HL (suspect) or above 90 dB HL (ambient noise or equipment issue).",
    finalScore: "Final Score",
    webAdaptations: "Adaptations for Web Environment",
    webAdaptationsDesc: "Unlike a calibrated clinical audiometer, HEAREN operates in an uncontrolled environment. Here are our adaptations:",
    relativeCalibration: "Relative Calibration",
    relativeCalibrationDesc: "Instead of absolute calibration (impossible without certified equipment), we use relative calibration based on user thresholds.",
    multiFreqValidation: "Multi-frequency Validation",
    multiFreqValidationDesc: "3 calibration points (vs typically 1) to detect hardware inconsistencies.",
    reliabilityScoring: "Reliability Scoring",
    reliabilityScoringDesc: "Transparency on measurement quality, allowing users to identify tests to redo.",
    safetyLimits: "Safety Limits",
    safetyLimitsDesc: "Maximum volume limited to 0.9 (90% amplitude) to prevent any hearing risk, even in case of error.",
    appropriateUse: "Appropriate Use of HEAREN",
    use1: "Preliminary Assessment",
    use1Desc: "Get a first indication of your hearing profile before ENT consultation.",
    use2: "Sound Personalization",
    use2Desc: "Adapt sound settings according to your profile.",
    use3: "Indicative Monitoring",
    use3Desc: "Compare evolution over time (with same conditions: headphones, environment).",
    use4: "Awareness",
    use4Desc: "Understand how an audiometric test works and the importance of hearing health.",
    bibliography: "Bibliography and References",
    questions: "Questions about our methodology?",
    contactDesc: "We are transparent about our approach and its limitations. For any technical or scientific questions, feel free to contact us.",

    // Clinical Audiogram Capture
    clinicalAudiogramFormatTitle: "What is the format of your audiogram?",
    clinicalAudiogramFormatDesc:
      "Tap the layout that matches your document.",
    clinicalAudiogramSingleFrame: "1 frame",
    clinicalAudiogramDualFrame: "2 frames",

    // Clinical Audiogram
    clinicalAudiogramTitle: "Read a Clinical Audiogram",
    clinicalAudiogramIntro:
      "If you have an audiogram performed by an ENT specialist or hearing care professional, Hearen can try to read it and build an initial overview of your hearing.",
    clinicalAudiogramFooter:
      "Hearen does not perform an audiogram. It reads a document created by a professional, then asks for your confirmation before adding anything to your profile.",
  }

};

export default translations;

